import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Search,
  DeleteForever,
} from "@mui/icons-material";
import "devextreme/data/odata/store";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Card, Col, Container, Dropdown, Form, Modal, Pagination, Row, Table, Button } from "react-bootstrap";
import * as yup from "yup";
import * as XLSX from "xlsx";

import API, { AxiosInstance, Settings } from "../../api/api";
import { parsedUser } from "../../utils/GetCurrentUser";
import { useLocation, useParams } from "react-router-dom";
import { TextBox, SelectBox, DateBox } from "devextreme-react";
import FieldSelector from "../../components/customComponents/FieldSelector";
import { useFormik } from "formik";
import Sha256 from "../../utils/sha256";
import logoSignos from "../../assets/SignosFrameworkLogo.png";

import { useToast } from "../../contexts/toast";
import yupTypeValidator from "../../utils/YupTypeValidator";
import { exportToPDF as GeneratePDF } from '../../utils/export-to-pdf';
import { exportToExcel as GenerateXLS } from '../../utils/export-to-excel';
import { CustomBreadcrumbs as Breadcrumbs } from "../../components";
import useFavorite from "../../hooks/useFavorite";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler";
import moment from "moment";
import "../../index.css";

export default function ImportToExcelSimple() {
  // PROPERTIES
  const user = parsedUser();
  const { pathname } = useLocation();
  const params = useParams();
  const { idModule } = useParams();
  const toast = useToast();
  const { handleApiResponse, ErrorModal } = useApiResponseHandler();

  const [recordCount, setRecordCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [generalError, setGeneralError] = useState(null);
  const [open, setOpen] = useState(false);
  const [actionMode, setActionMode] = useState(null);//I=Insert, U= Update = C= Consultar, D= Delete
  const [loading, setLoading] = useState(false);
  // const [isPinned, setIsPinned] = useState(false);
  const checkAudit = localStorage.getItem('AuditInformation')

  const initialModel = {
    section: {},
    data: {
      Columns: [],
      Rows: [],
    },
  }
  const [section, setSection] = useState(null);
  const [fields, setFields] = useState([])
  const [filters, setFilters] = useState([]); // Filtros dinámicos del Model
  const [filterValues, setFilterValues] = useState({}); // Valores de los filtros dinámicos
  const [model, setModel] = useState(initialModel);
  const [search, setSearch] = useState(""); // Búsqueda general (string simple)
  const [columnFilters, setColumnFilters] = useState({}); // Filtros por columna (objeto)
  const [openFilterColumn, setOpenFilterColumn] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [RecordsQuantity, setRecordsQuantity] = useState(10);
  const allowedPageSizes = [{ value: 10, text: 10 }, { value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }, { value: 0, text: "Todos" }];
  const [selectedItem, setSelectedItem] = useState(null);
  const { isPinned, UpdateFavorites, checkIfPinned } = useFavorite()
  const selectedItemRef = useRef(null);
  const [sortBy, setSortBy] = useState('Id')
  const [sortByOrder, setSortByOrder] = useState('DESC')
  const [formSize, setFormSize] = useState('md');
  const [tableHeader, setTableHeader] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true); // Estado para controlar carga de filtros
  const [showTable, setShowTable] = useState(false); // Ocultar tabla hasta que se consulte
  
  // Estados para subida de archivos
  const [selectedFiles, setSelectedFiles] = useState([]); // Array de archivos: [{file, comentario}]
  const [uploadingFiles, setUploadingFiles] = useState(false);
  
  // Estados para visor de archivos en pantalla completa
  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentFileIndex, setCurrentFileIndex] = useState(0);
  
  // Funciones para el visor de archivos
  const openFileViewer = (index) => {
    setCurrentFileIndex(index);
    setViewerOpen(true);
  };

  const closeFileViewer = () => {
    setViewerOpen(false);
  };

  const goToPreviousFile = () => {
    setCurrentFileIndex((prev) => (prev > 0 ? prev - 1 : selectedFiles.length - 1));
  };

  const goToNextFile = () => {
    setCurrentFileIndex((prev) => (prev < selectedFiles.length - 1 ? prev + 1 : 0));
  };

  // Función para inicializar valores por defecto de los filtros
  const initializeFilterDefaults = useCallback((filters) => {
    const defaults = {};
    const today = new Date();
    
    filters.forEach(filter => {
      if (filter.DefaultValue) {
        // Usar el valor DefaultValue del API si existe
        let defaultValue = filter.DefaultValue;
        
        // Si el filtro es de tipo date, convertir formato según el caso
        if (filter.HtmlType === 'date' && typeof defaultValue === 'string') {
          // Si viene en formato YYYYMMDD (sin guiones) -> convertir a YYYY-MM-DD
          if (defaultValue.length === 8 && !defaultValue.includes('-')) {
            const year = defaultValue.substring(0, 4);
            const month = defaultValue.substring(4, 6);
            const day = defaultValue.substring(6, 8);
            defaultValue = `${year}-${month}-${day}`;
          }
          // Si viene en formato DD-MM-YYYY -> convertir a YYYY-MM-DD
          else if (defaultValue.includes('-') && defaultValue.length === 10) {
            const parts = defaultValue.split('-');
            if (parts.length === 3 && parts[0].length <= 2) {
              defaultValue = `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
          }
        }
        
        defaults[filter.FieldName] = defaultValue;
      } else if (filter.HtmlType === 'date') {
        // Si el filtro es FechaEntrada o contiene "Inicio" -> primer día del mes
        if (filter.FieldName === 'FechaEntrada' || filter.FieldTitle.includes('Inicio') || filter.FieldName.includes('Ini')) {
          const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
          defaults[filter.FieldName] = firstDay.toISOString().split('T')[0];
        }
        // Si el filtro es FechaSalida o contiene "Fin" -> último día del mes
        else if (filter.FieldName === 'FechaSalida' || filter.FieldTitle.includes('Fin') || filter.FieldName.includes('Fin')) {
          const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
          defaults[filter.FieldName] = lastDay.toISOString().split('T')[0];
        }
      } else {
        defaults[filter.FieldName] = '';
      }
    });
    
    return defaults;
  }, []);
  
  // Filter helper functions
  const updateColumnFilter = (fieldName, value) => {
    setColumnFilters(prev => ({
      ...prev,
      [fieldName]: value
    }));
  };

  const clearAllFilters = async () => {
    setSearch("");
    setColumnFilters({});
    setOpenFilterColumn(null);
    setTimeout(async () => {
      // await bindDataRemote(true); // DESACTIVADO
      // await bindDataCountRemote(true); // DESACTIVADO
    }, 100);
  };

  const toggleFilterDropdown = (fieldName) => {
    setOpenFilterColumn(openFilterColumn === fieldName ? null : fieldName);
  };

  const applyColumnFilter = async () => {
    setOpenFilterColumn(null);
    // await bindDataRemote(); // DESACTIVADO
    // await bindDataCountRemote(); // DESACTIVADO
  };

  const clearSingleColumnFilter = async (fieldName) => {
    setColumnFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[fieldName];
      return newFilters;
    });
    setTimeout(async () => {
      // await bindDataRemote(); // DESACTIVADO
      // await bindDataCountRemote(); // DESACTIVADO
    }, 100);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openFilterColumn && !event.target.closest('.position-relative')) {
        setOpenFilterColumn(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openFilterColumn]);
  
  // END PROPERTIES



  //METHODS
  // Función para obtener los registros de la página actual
  const getCurrentPageData = useCallback(() => {
    if (!model?.data?.Rows || model.data.Rows.length === 0) {
      return [];
    }
    
    // Si RecordsQuantity es 0 o "Todos", retornar todos los registros
    if (RecordsQuantity === 0 || RecordsQuantity === '0') {
      return model.data.Rows;
    }
    
    // Calcular índices de inicio y fin para la página actual
    const startIndex = (currentPage - 1) * parseInt(RecordsQuantity);
    const endIndex = startIndex + parseInt(RecordsQuantity);
    
    // Retornar el subconjunto de registros
    return model.data.Rows.slice(startIndex, endIndex);
  }, [model?.data?.Rows, currentPage, RecordsQuantity]);

  ///BRING THE DATA FROM THE SERVER FOR MODEL AND RECORDS
  /* FUNCIÓN DESACTIVADA - Ya no se usa bindDataRemote
  const bindDataRemote = useCallback(async (cleanFilter) => {

    // First start loading the model
    setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Construir objeto de búsqueda con FechaIni y FechaFin
      let searchObject = {};
      
      if (cleanFilter == null) {
        // Prioridad 1: Usar filterValues si están disponibles
        if (Object.keys(filterValues).length > 0) {
          searchObject = { ...filterValues };
          console.log("📅 Usando filterValues para búsqueda:", searchObject);
        } 
        // Prioridad 2: Usar valores por defecto desde tableHeader
        else {
          const firstDayThisYear = moment().startOf('year').format('YYYY-MM-DD'); // 01 de enero este año
          const firstDayNextYear = moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'); // 01 de enero próximo año
          
          // Intentar obtener desde tableHeader DefaultValue
          if (tableHeader && tableHeader.length > 0) {
            const fechaIniField = tableHeader.find(f => f.FieldName === 'FechaIni' || f.FieldName === 'FechaEntrada');
            const FechaFinField = tableHeader.find(f => f.FieldName === 'FechaFin' || f.FieldName === 'FechaFin' || f.FieldName === 'FechaSalida');
            
            if (fechaIniField && fechaIniField.DefaultValue) {
              let fechaIni = fechaIniField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (fechaIni.length === 8 && !fechaIni.includes('-')) {
                fechaIni = `${fechaIni.substring(0, 4)}-${fechaIni.substring(4, 6)}-${fechaIni.substring(6, 8)}`;
              } else if (fechaIni.includes('-') && fechaIni.length === 10) {
                const parts = fechaIni.split('-');
                if (parts[0].length <= 2) {
                  fechaIni = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaIni = fechaIni;
            } else {
              // Si no hay DefaultValue, usar 01 de enero de este año
              searchObject.FechaIni = firstDayThisYear;
            }
            
            if (FechaFinField && FechaFinField.DefaultValue) {
              let FechaFin = FechaFinField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (FechaFin.length === 8 && !FechaFin.includes('-')) {
                FechaFin = `${FechaFin.substring(0, 4)}-${FechaFin.substring(4, 6)}-${FechaFin.substring(6, 8)}`;
              } else if (FechaFin.includes('-') && FechaFin.length === 10) {
                const parts = FechaFin.split('-');
                if (parts[0].length <= 2) {
                  FechaFin = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaFin = FechaFin;
            } else {
              // Si no hay DefaultValue, usar 01 de enero del próximo año
              searchObject.FechaFin = firstDayNextYear;
            }
          } else {
            // Si no hay tableHeader, usar 01 de enero de este año y próximo año
            searchObject.FechaIni = firstDayThisYear;
            searchObject.FechaFin = firstDayNextYear;
          }
        }
      }
      
      // Agregar fechas al query como parámetro Search
      if (Object.keys(searchObject).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(searchObject));
      }
      // Filtros por columna tienen prioridad
      else if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros
        query += "&Search=" + search;
      }
      
      query += `&SortBy=${sortBy}&SortType=${sortByOrder}`;
      let quantity = RecordsQuantity === 0 ? recordCount : RecordsQuantity;
      query = query + `&Quantity=${quantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/Records`, query);
      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];

      let recordResult = parsedResults.JSONData || [];
      // let configInfo = recordResult[0].JSONConfig ? recordResult[0].JSONConfig[0] : null;
      let dataFromAPI = recordResult[0] ? (recordResult[0].JSONConfig ? recordResult[0].JSONData : recordResult) : [];
      console.log("✅ Datos cargados:", dataFromAPI.length, "registros");


      //TODO: | Use JSONConfig to show specific fields
      let gridData = null;
      let gridColumns = dataFromAPI && dataFromAPI.length > 0 ? Object.keys(dataFromAPI[0]).filter(x => !x.startsWith("Id")) : null;

      //! If grid data stays null, we use the data from the API

      let titles = ['Audit Information', 'Added by', 'Date Added', 'Modified by', 'Last Modified']

      // setModel({
      //   ...model,
      //
      //   data: {
      //     ...model.data,
      //     Columns: gridColumns,
      //     Rows: gridData || dataFromAPI,
      //   },
      // });
      //debugger;
      setModel({
        ...model,
        
        data: {
          ...model.data,
          Columns: gridColumns,
          Rows: dataFromAPI,
        },
      });



    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line
  }, [currentPage, search, columnFilters, sortBy, sortByOrder, RecordsQuantity, params.id, idModule, tableHeader, filterValues]);
  */ // FIN FUNCIÓN DESACTIVADA bindDataRemote


  useEffect(() => {
    setTableHeader([])
    // NO llamar bindDataRemote aquí - se llamará después de cargar los filtros
    setSelectedItem(null);
  }, [params.id, idModule])

  useEffect(() => {
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      // bindDataRemote(); // DESACTIVADO
      setSelectedItem(null);
    }
  }, [currentPage])

  /* FUNCIÓN DESACTIVADA - Ya no se usa bindDataCountRemote
  const bindDataCountRemote = async (cleanFilter) => {

    // First start loading the model
    //setLoading(true);

    //First load records

    try {
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      
      // Construir objeto de búsqueda con FechaIni y FechaFin
      let searchObject = {};
      
      if (cleanFilter == null) {
        // Prioridad 1: Usar filterValues si están disponibles
        if (Object.keys(filterValues).length > 0) {
          searchObject = { ...filterValues };
          console.log("📅 Usando filterValues para conteo:", searchObject);
        } 
        // Prioridad 2: Usar valores por defecto desde tableHeader
        else {
          const firstDayThisYear = moment().startOf('year').format('YYYY-MM-DD'); // 01 de enero este año
          const firstDayNextYear = moment().add(1, 'year').startOf('year').format('YYYY-MM-DD'); // 01 de enero próximo año
          
          // Intentar obtener desde tableHeader DefaultValue
          if (tableHeader && tableHeader.length > 0) {
            const fechaIniField = tableHeader.find(f => f.FieldName === 'FechaIni' || f.FieldName === 'FechaEntrada');
            const FechaFinField = tableHeader.find(f => f.FieldName === 'FechaFin' || f.FieldName === 'FechaFin' || f.FieldName === 'FechaSalida');
            
            if (fechaIniField && fechaIniField.DefaultValue) {
              let fechaIni = fechaIniField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (fechaIni.length === 8 && !fechaIni.includes('-')) {
                fechaIni = `${fechaIni.substring(0, 4)}-${fechaIni.substring(4, 6)}-${fechaIni.substring(6, 8)}`;
              } else if (fechaIni.includes('-') && fechaIni.length === 10) {
                const parts = fechaIni.split('-');
                if (parts[0].length <= 2) {
                  fechaIni = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaIni = fechaIni;
            } else {
              // Si no hay DefaultValue, usar 01 de enero de este año
              searchObject.FechaIni = firstDayThisYear;
            }
            
            if (FechaFinField && FechaFinField.DefaultValue) {
              let FechaFin = FechaFinField.DefaultValue;
              // Convertir a YYYY-MM-DD si viene en otro formato
              if (FechaFin.length === 8 && !FechaFin.includes('-')) {
                FechaFin = `${FechaFin.substring(0, 4)}-${FechaFin.substring(4, 6)}-${FechaFin.substring(6, 8)}`;
              } else if (FechaFin.includes('-') && FechaFin.length === 10) {
                const parts = FechaFin.split('-');
                if (parts[0].length <= 2) {
                  FechaFin = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
              }
              searchObject.FechaFin = FechaFin;
            } else {
              // Si no hay DefaultValue, usar 01 de enero del próximo año
              searchObject.FechaFin = firstDayNextYear;
            }
          } else {
            // Si no hay tableHeader, usar 01 de enero de este año y próximo año
            searchObject.FechaIni = firstDayThisYear;
            searchObject.FechaFin = firstDayNextYear;
          }
        }
      }
      
      // Agregar fechas al query como parámetro Search
      if (Object.keys(searchObject).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(searchObject));
      }
      // Filtros por columna tienen prioridad
      else if (Object.keys(columnFilters).length > 0 && cleanFilter == null) {
        query += "&Search=" + encodeURIComponent(JSON.stringify(columnFilters));
      } else if (search.length > 0 && cleanFilter == null) {
        // Búsqueda general solo si no hay filtros
        query += "&Search=" + search;
      }

      query = query + `&Quantity=${RecordsQuantity}&pageNumber=${currentPage}`
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let request = await API.getAction(`api/${prefix}/RecordsCount`, query);


      let results = request.data[0];
      let parsedResults = JSON.parse(results.JSONData)[0];
      setRecordCount(parsedResults.JSONData.Count);
      console.log("Record Count that comes from api ", parsedResults.JSONData.Count)


    } catch (error) {
      console.error(error);
    } finally {
      // setLoading(false);
    }
  };
  */ // FIN FUNCIÓN DESACTIVADA bindDataCountRemote

  const bindDataModelRemote = async (cleanFilter) => {


    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      let requestSections = await API.getAction(`api/${prefix}/Model`, querySections);
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      let recordResultSection = parsedResultsSections.JSONData;

      //! If grid data stays null, we use the data from the API

      let titles = ['Informacion de auditoria']
      console.log(recordResultSection)
      setSection(recordResultSection[0]);
      setFields(recordResultSection[0].Fields.filter((item) => !titles.includes(item.FieldTitle)));

    } catch (error) {
      console.error(error);
    } finally {
      //  setLoading(false);
    }
  };
  
  useEffect(() => {

  })
  const bindDataHeaderRemote = async (cleanFilter) => {

    console.log("🔄 bindDataHeaderRemote iniciado");
    try {

      let prefix = idModule ? "CRUDDynamic" : "CRUD";

      //Now let's load sections
      let querySections = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}${idModule ? "&IdModule=" + idModule : ""}`;
      console.log("🔄 Llamando a Header con query:", querySections);
      let requestSections = await API.getAction(`api/${prefix}/Header`, querySections);
      console.log("📋 Header response:", requestSections)
      
      let resultsSections = requestSections.data[0];
      let parsedResultsSections = JSON.parse(resultsSections.JSONData)[0];
      console.log("📋 Header parsed:", parsedResultsSections)
      
      if (parsedResultsSections && (parsedResultsSections.Error || parsedResultsSections.Logout || parsedResultsSections.Expired)) {
        if (handleApiResponse(parsedResultsSections)) {
          return;
        }
      }

      // El JSONData puede venir como array o como objeto
      let recordResultSection = Array.isArray(parsedResultsSections.JSONData) 
        ? parsedResultsSections.JSONData[0] 
        : parsedResultsSections.JSONData;
      console.log("📋 recordResultSection:", recordResultSection);
      
      setFormSize(recordResultSection.FormSize ?? 'lg');

      //! If grid data stays null, we use the data from the API
      let titles = ['Informacion de auditoria']
      console.log("📋 Fields a cargar:", recordResultSection.Fields);

      // Asegurar que Fields sea un array válido antes de configurar
      if (recordResultSection.Fields && Array.isArray(recordResultSection.Fields)) {
        setTableHeader(recordResultSection.Fields);
        console.log("✅ TableHeader configurado con", recordResultSection.Fields?.length, "campos");
      } else {
        console.error("❌ Fields no es un array válido:", recordResultSection.Fields);
        setTableHeader([]);
      }
      
      // Cargar filtros dinámicos si existen
      if (recordResultSection.Filters && recordResultSection.Filters.length > 0) {
        setFilters(recordResultSection.Filters);
        console.log("✅ Filtros cargados:", recordResultSection.Filters);
        
        // Inicializar valores por defecto de los filtros inmediatamente
        const defaultValues = initializeFilterDefaults(recordResultSection.Filters);
        setFilterValues(defaultValues);
        console.log("✅ Filtros inicializados inmediatamente con valores:", defaultValues);
      } else {
        setFilters([]);
        setFilterValues({}); // Filtros vacíos si no hay filtros definidos
        console.log("⚠️ No hay filtros definidos en el modelo");
        // Si no hay filtros, ejecutar bindDataRemote directamente
        setTimeout(async () => {
          // await bindDataRemote(); // DESACTIVADO
          // await bindDataCountRemote(); // DESACTIVADO
          setShowTable(true);
        }, 100);
      }
      
      setLoadingFilters(false); // Finalizar carga de filtros

    } catch (error) {
      console.error("❌ Error en bindDataHeaderRemote:", error);
      setLoadingFilters(false);
      // En caso de error, asegurar que tableHeader sea un array vacío
      setTableHeader([]);
    } finally {
      //  setLoading(false);
    }
  };

  useEffect(() => { 
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      // bindDataRemote(); // DESACTIVADO
    }
  }, [checkAudit])

  const bindDataDetailsRemote = async (recordId) => {
    //First load records
    try {
      let prefix = idModule ? "CRUDDynamic" : "CRUD";
      let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${recordId}${idModule ? "&IdModule=" + idModule : ""}`;
      let request = await API.getAction(`api/${prefix}/Details`, query);
      let results = request.data[0];

      let parsedResults = JSON.parse(results.JSONData)[0];
      if (parsedResults && (parsedResults.Error || parsedResults.Logout || parsedResults.Expired)) {
        if (handleApiResponse(parsedResults)) {
          return;
        }
      }

      let finalResult = parsedResults.JSONData;
      fillFormikObject(finalResult);
      
      // Cargar archivos existentes si hay NovedadesDocumentos
      if (finalResult.NovedadesDocumentos && finalResult.NovedadesDocumentos.length > 0) {
        console.log("📁 Cargando documentos existentes:", finalResult.NovedadesDocumentos);
        
        const existingFiles = finalResult.NovedadesDocumentos.map(doc => {
          // Detectar tipo de archivo por extensión
          const fileName = doc.Documento.toLowerCase();
          const isImage = /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(fileName);
          const isPDF = /\.pdf$/i.test(fileName);
          const isVideo = /\.(mp4|webm|mov|avi|mkv)$/i.test(fileName);
          
          return {
            id: doc.Id, // ID del documento en BD
            file: {
              name: doc.Documento,
              size: 0 // No tenemos el tamaño desde el servidor
            },
            comentario: doc.Comentario || '',
            previewUrl: doc.Ruta, // URL del servidor
            isImage,
            isPDF,
            isVideo,
            isExisting: true, // Flag para saber que ya existe en servidor
            isReplacing: false, // Flag para saber si se va a reemplazar
            documentId: doc.Id, // ID para eliminar o actualizar
            originalFileName: doc.Documento, // Nombre original del documento
            guid: doc.GUID
          };
        });
        
        setSelectedFiles(existingFiles);
        console.log("✅ Archivos existentes cargados:", existingFiles.length);
      } else {
        setSelectedFiles([]);
      }
      
      setSelectedItem(null)
    } catch (error) {
      console.error(error)
    }
    //Fill object with new values
  };

  //Open edit/add mode
  const toggleOpen = async (action, reload, itemToUse = null) => {
    setActionMode(action);

    if (action === null) {
      setSelectedItem(null);
      formik.resetForm();
      // Limpiar URLs de preview antes de limpiar archivos (solo los locales)
      selectedFiles.forEach(fileData => {
        if (fileData.previewUrl && !fileData.isExisting) {
          URL.revokeObjectURL(fileData.previewUrl);
        }
      });
      setSelectedFiles([]); // Limpiar archivos al cerrar
    }

    if (action === "I") {
      setSelectedItem(null);
      setSelectedFiles([]); // Limpiar archivos al abrir crear
      
      // Establecer fecha de hoy por defecto en campos de fecha
      setTimeout(() => {
        const today = moment().format('YYYY-MM-DD'); // Formato interno del backend
        if (fields && fields.length > 0) {
          fields.forEach((field) => {
            if (field.HtmlType === 'date' && !field.ReadOnly) {
              formik.setFieldValue(field.FieldName, today);
            }
          });
        }
      }, 100);
    }
    if (action === "U" || action === "C" || action === "D") {
      setOpen(!open);
      
      // Usar itemToUse si se proporciona, de lo contrario usar selectedItem
      const currentItem = itemToUse || selectedItem;
      
      console.log('🔍 toggleOpen - action:', action, 'currentItem:', currentItem);
      
      if (currentItem) {
        // Usar fillFormikObject para llenar el formulario correctamente
        setTimeout(() => {
          fillFormikObject(currentItem);
          console.log('✅ Formulario llenado con fillFormikObject:', currentItem);
        }, 100);
      } else {
        console.error('❌ No se encontró item seleccionado para cargar los detalles');
      }
    }

    if (selectedItemRef.current) {
      selectedItemRef.current.clearSelection();
    }

    setGeneralError(null);
    setOpen(!open);
    if (reload) {
      // bindDataRemote(); // DESACTIVADO
    }
  };

  // Función para navegar al registro anterior
  const navigateToPreviousRecord = () => {
    const currentData = getCurrentPageData();
    const currentIndex = currentData.findIndex(item => item.Id === selectedItem?.Id);
    
    if (currentIndex > 0) {
      const previousItem = currentData[currentIndex - 1];
      setSelectedItem(previousItem);
      
      // Usar fillFormikObject para llenar correctamente el formulario
      setTimeout(() => {
        fillFormikObject(previousItem);
        console.log('⬅️ Navegando al registro anterior:', previousItem);
      }, 50);
    }
  };

  // Función para navegar al registro siguiente
  const navigateToNextRecord = () => {
    const currentData = getCurrentPageData();
    const currentIndex = currentData.findIndex(item => item.Id === selectedItem?.Id);
    
    if (currentIndex < currentData.length - 1) {
      const nextItem = currentData[currentIndex + 1];
      setSelectedItem(nextItem);
      
      // Usar fillFormikObject para llenar correctamente el formulario
      setTimeout(() => {
        fillFormikObject(nextItem);
        console.log('➡️ Navegando al registro siguiente:', nextItem);
      }, 50);
    }
  };

  // Función para verificar si hay registro anterior
  const hasPreviousRecord = () => {
    const currentData = getCurrentPageData();
    const currentIndex = currentData.findIndex(item => item.Id === selectedItem?.Id);
    return currentIndex > 0;
  };

  // Función para verificar si hay registro siguiente
  const hasNextRecord = () => {
    const currentData = getCurrentPageData();
    const currentIndex = currentData.findIndex(item => item.Id === selectedItem?.Id);
    return currentIndex >= 0 && currentIndex < currentData.length - 1;
  };

  //Delete the record
  const deleteConfirm = async (obj) => {
    const mensajeConfirmacion = "¿Confirma que desea eliminar este registro?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "No" al backend con DialogText y DialogResp
                  let prefix = idModule ? "CRUDDynamic" : "CRUD";
                  let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
                  await API.getAction(`api/${prefix}/Delete`, query);
                }}
                style={{ width: '120px' }}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "Si" al backend con DialogText y DialogResp
                  let prefix = idModule ? "CRUDDynamic" : "CRUD";
                  let query = `IdUser=${user.IdUser}&id=${params.id}&token=${user.Token}&RecordId=${selectedItem.GUID}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
                  await API.getAction(`api/${prefix}/Delete`, query);
                  // await bindDataRemote(); // DESACTIVADO
                  setSelectedItem(null);
                  
                  toast({
                    type: "success",
                    message: "Registro eliminado correctamente"
                  });
                }}
                style={{ width: '120px' }}
              >
                Confirmar
              </button>
            </div>
          </div>
        );
      }
    });
  };

  // Función para imprimir/reportar (ejecutar y mostrar PDF)
  const handlePrintReport = async (item) => {
    try {
      console.log("🖨️ Iniciando impresión para item:", item);
      console.log("🔍 Campos disponibles en item:", Object.keys(item));
      
      // Preparar los parámetros del query
      const queryParams = new URLSearchParams({
        Token: user.Token,
        IdUser: user.IdUser.toString(),
        Accion: "R"
      });
      
      // Usar la URL base configurada en Settings.APIPath
      const baseURL = Settings.APIPath.endsWith('/') 
        ? Settings.APIPath.slice(0, -1) 
        : Settings.APIPath;
      
      const url = `${baseURL}/api/OcupacionProcesos/CRUDeasNovedades?${queryParams.toString()}`;
      
      console.log("🔗 URL de impresión:", url);
      
      // Hacer la petición POST para obtener el HTML
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`Error al obtener el reporte: ${response.status}`);
      }
      
      // Parsear el JSON de respuesta
      const jsonResponse = await response.json();
      console.log("✅ JSON Response completo:", jsonResponse);
      console.log("✅ Tipo de jsonResponse:", typeof jsonResponse);
      console.log("✅ Es array?:", Array.isArray(jsonResponse));
      
      // Función recursiva para buscar HtmlText en cualquier nivel
      const findHtmlText = (obj, path = '') => {
        if (!obj || typeof obj !== 'object') return null;
        
        // Si el objeto actual tiene HtmlText, devolverlo
        if (obj.HtmlText) {
          console.log(`✅ HtmlText encontrado en: ${path || 'raíz'}`);
          return obj.HtmlText;
        }
        
        // Si es un array, buscar en el primer elemento
        if (Array.isArray(obj) && obj.length > 0) {
          return findHtmlText(obj[0], `${path}[0]`);
        }
        
        // Buscar en propiedades comunes primero (optimización)
        const commonPaths = ['ReportData', 'JSONData', 'Data'];
        for (const key of commonPaths) {
          if (obj[key]) {
            const result = findHtmlText(obj[key], `${path}.${key}`);
            if (result) return result;
          }
        }
        
        // Buscar en todas las demás propiedades
        for (const key in obj) {
          if (!commonPaths.includes(key) && obj.hasOwnProperty(key)) {
            const result = findHtmlText(obj[key], `${path}.${key}`);
            if (result) return result;
          }
        }
        
        return null;
      };
      
      // Extraer el HTML usando la búsqueda recursiva
      let htmlContent = '';
      
      // Intentar parsear JSONData si existe (caso común)
      if (Array.isArray(jsonResponse) && jsonResponse.length > 0 && jsonResponse[0].JSONData) {
        try {
          const firstItem = jsonResponse[0];
          const parsedData = typeof firstItem.JSONData === 'string' 
            ? JSON.parse(firstItem.JSONData) 
            : firstItem.JSONData;
          
          console.log("📊 Parsed JSONData:", parsedData);
          htmlContent = findHtmlText(parsedData, 'JSONData');
        } catch (e) {
          console.warn("⚠️ Error al parsear JSONData:", e);
        }
      }
      
      // Si no se encontró, buscar en toda la respuesta
      if (!htmlContent) {
        htmlContent = findHtmlText(jsonResponse, 'root');
      }
      
      if (!htmlContent) {
        console.error("❌ No se encontró HtmlText en ningún nivel de la respuesta");
        console.error("❌ Estructura completa de la respuesta:", JSON.stringify(jsonResponse, null, 2));
        throw new Error("No se encontró contenido HTML en la respuesta del servidor");
      }
      
      // Limpiar el HTML: eliminar TODOS los escapes
      htmlContent = htmlContent
        .replace(/\\r\\n/g, '\n')      // Reemplazar \r\n escapados con saltos de línea reales
        .replace(/\\r/g, '\r')          // Reemplazar \r escapados
        .replace(/\\n/g, '\n')         // Reemplazar \n escapados
        .replace(/\\t/g, '\t')         // Reemplazar \t escapados
        .replace(/\\"/g, '"')          // Reemplazar \" con "
        .replace(/\\'/g, "'")          // Reemplazar \' con '
        .replace(/\\\//g, '/')         // Reemplazar \/ con /
        .replace(/\\\\/g, '\\')        // Reemplazar \\ con \
        .trim();                       // Eliminar espacios al inicio y final
      
      console.log("📄 HTML después de limpieza:");
      console.log(htmlContent.substring(0, 500)); // Ver primeros 500 caracteres
      
      // Modificar @page para establecer márgenes en 0 (None)
      if (htmlContent.includes('@page')) {
        htmlContent = htmlContent.replace(
          /@page\s*{\s*margin:\s*[^;]+;/g,
          '@page { margin: 0;'
        );
      } else {
        // Si no existe @page, agregarlo antes del cierre de </style>
        htmlContent = htmlContent.replace(
          '</style>',
          '@page { margin: 0; }\n  </style>'
        );
      }
      
      console.log("✅ HTML limpiado y configurado, longitud:", htmlContent.length);
      
      // Abrir una nueva ventana y escribir el HTML
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.open();
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        
        // Esperar a que se cargue completamente y luego activar impresión
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
          }, 250);
        };
        
        console.log("✅ Reporte abierto en nueva ventana y listo para imprimir");
        
        toast({
          type: "success",
          message: "Reporte generado exitosamente"
        });
      } else {
        toast({
          type: "error",
          message: "No se pudo abrir la ventana de impresión. Por favor, habilita las ventanas emergentes."
        });
      }
      
    } catch (error) {
      console.error("❌ Error al imprimir:", error);
      toast({
        type: "error",
        message: `Error al generar el reporte: ${error.message}`
      });
    }
  };

  // Función para convertir un registro en formato JSON (todos los valores como string)
  const convertRowToJSON = (row) => {
    const jsonObject = {};
    const visibleColumns = headerWithoutAuditFields();
    
    visibleColumns.forEach((column) => {
      if (column.ReadOnly || column.HtmlType === "separator") return;
      
      const fieldValue = row[column.FieldName];
      
      // Convertir todos los valores a string, excepto null
      if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
        // Si hay DefaultValue, usarlo como string, sino null
        jsonObject[column.FieldName] = (column.DefaultValue && column.DefaultValue.length > 0) 
          ? String(column.DefaultValue) 
          : null;
      } else {
        // Convertir todo a string (números, booleanos, fechas, etc.)
        jsonObject[column.FieldName] = String(fieldValue);
      }
    });
    
    return jsonObject;
  };

  // Función para procesar la importación de registros
  const processImportation = async () => {
    if (!model?.data?.Rows || model.data.Rows.length === 0) {
      toast({
        type: "warning",
        message: "No hay registros para procesar"
      });
      return;
    }
    
    const mensajeConfirmacion = `¿Confirma que desea procesar la importación de ${model.data.Rows.length} registro(s)?`;
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={() => {
                  console.log("❌ Importación cancelada por el usuario");
                  onClose();
                }}
                style={{ width: '120px' }}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  
                  try {
                    setLoading(true);
                    console.log("🚀 Iniciando proceso de importación...");
                    
                    // Convertir cada registro a formato JSON
                    const dataArray = model.data.Rows.map((row, index) => {
                      const jsonObject = convertRowToJSON(row);
                      console.log(`📝 Registro ${index + 1}/${model.data.Rows.length}:`, jsonObject);
                      return jsonObject;
                    });
                    
                    console.log("📦 Total de registros a procesar:", dataArray.length);
                    
                    // Dividir en bloques de 10
                    const BLOCK_SIZE = 10;
                    const totalBlocks = Math.ceil(dataArray.length / BLOCK_SIZE);
                    let successCount = 0;
                    let errorCount = 0;
                    let lastMessage = null; // Para guardar el último mensaje del backend
                    
                    console.log(`📊 Se procesarán ${totalBlocks} bloque(s) de ${BLOCK_SIZE} registros`);
                    
                    // Procesar cada bloque
                    for (let i = 0; i < totalBlocks; i++) {
                      const startIndex = i * BLOCK_SIZE;
                      const endIndex = Math.min(startIndex + BLOCK_SIZE, dataArray.length);
                      const block = dataArray.slice(startIndex, endIndex);
                      
                      console.log(`📦 Procesando bloque ${i + 1}/${totalBlocks} (registros ${startIndex + 1}-${endIndex})...`);
                      
                      try {
                        // Preparar el query string
                        const queryString = `Token=${user.Token}&IdUser=${user.IdUser}&Accion=P`;
                        
                        // Preparar el payload con el bloque actual
                        const payload = {
                          Data: block
                        };
                        
                        console.log(`🌐 Enviando bloque ${i + 1} a ImportacionColaboradores...`);
                        console.log("📋 Query:", queryString);
                        console.log("📦 Payload del bloque:", payload);
                        
                        // Hacer la petición POST
                        const response = await API.postAction(
                          `api/OcupacionProcesos/ImportacionColaboradores?${queryString}`,
                          payload
                        );
                        
                        console.log(`✅ Respuesta del servidor (bloque ${i + 1}):`, response);
                        
                        if (response.status === 200) {
                          let responseData = response.data;
                          
                          // Intentar parsear si viene como string JSON
                          if (typeof responseData === 'string') {
                            try {
                              responseData = JSON.parse(responseData);
                              console.log("📋 JSON parseado:", responseData);
                            } catch (e) {
                              console.warn("⚠️ No se pudo parsear respuesta como JSON");
                            }
                          }
                          
                          // Si es un array, tomar el primer elemento
                          if (Array.isArray(responseData) && responseData.length > 0) {
                            responseData = responseData[0];
                            console.log("📋 Primer elemento del array:", responseData);
                          }
                          
                          // Verificar si hay error
                          if (responseData.Error) {
                            console.error(`❌ Error en bloque ${i + 1}:`, responseData.Msg);
                            errorCount += block.length;
                            
                            toast({
                              type: "error",
                              message: `Error en bloque ${i + 1}: ${responseData.Msg || "Error desconocido"}`
                            });
                          } else {
                            successCount += block.length;
                            
                            // Guardar el mensaje si existe en JSONData
                            // JSONData puede venir como string, así que parsearlo primero
                            let jsonData = responseData.JSONData;
                            if (typeof jsonData === 'string') {
                              try {
                                jsonData = JSON.parse(jsonData);
                                console.log("📋 JSONData parseado:", jsonData);
                                
                                // Si es un array, tomar el primer elemento
                                if (Array.isArray(jsonData) && jsonData.length > 0) {
                                  jsonData = jsonData[0];
                                  console.log("📋 Primer elemento de JSONData:", jsonData);
                                  
                                  // A veces hay otro JSONData anidado, verificar
                                  if (jsonData.JSONData) {
                                    jsonData = jsonData.JSONData;
                                    console.log("📋 JSONData anidado encontrado:", jsonData);
                                  }
                                }
                              } catch (e) {
                                console.warn("⚠️ No se pudo parsear JSONData como JSON:", e);
                              }
                            }
                            
                            if (jsonData && jsonData.Mensaje) {
                              lastMessage = jsonData.Mensaje;
                              console.log(`💬 Mensaje guardado del bloque ${i + 1}:`, lastMessage);
                              console.log(`📢 MsgTitle: "${lastMessage.MsgTitle}", MsgBody: "${lastMessage.MsgBody}"`);
                            } else {
                              console.log("⚠️ No se encontró Mensaje en jsonData:", jsonData);
                            }
                            
                            console.log(`✅ Bloque ${i + 1} procesado exitosamente (${block.length} registros)`);
                          }
                        } else {
                          errorCount += block.length;
                          console.error(`❌ Error HTTP en bloque ${i + 1}:`, response.status);
                        }
                        
                      } catch (blockError) {
                        errorCount += block.length;
                        console.error(`❌ Error al procesar bloque ${i + 1}:`, blockError);
                        toast({
                          type: "error",
                          message: `Error en bloque ${i + 1}: ${blockError.message || 'Error desconocido'}`
                        });
                      }
                      
                      // Pequeña pausa entre bloques (opcional, para no saturar el servidor)
                      if (i < totalBlocks - 1) {
                        await new Promise(resolve => setTimeout(resolve, 300));
                      }
                    }
                    
                    // Resumen final
                    console.log("📊 Resumen de importación:");
                    console.log(`✅ Registros exitosos: ${successCount}`);
                    console.log(`❌ Registros con error: ${errorCount}`);
                    
                    if (successCount > 0) {
                      // Si hay mensaje del backend, mostrarlo; sino mostrar mensaje por defecto
                      let toastMessage = '';
                      if (lastMessage && lastMessage.MsgTitle && lastMessage.MsgBody) {
                        // Crear mensaje con dos líneas separadas (el toast renderiza HTML)
                        toastMessage = (
                          <div>
                            <div className="fw-bold">{lastMessage.MsgTitle}</div>
                            <div>{lastMessage.MsgBody}</div>
                          </div>
                        );
                      } else {
                        toastMessage = `Importación completada: ${successCount} registro(s) procesado(s) exitosamente${errorCount > 0 ? `, ${errorCount} con error` : ''}`;
                      }
                      
                      toast({
                        type: "success",
                        message: toastMessage
                      });
                      
                      // Limpiar la tabla y los datos solo si hubo éxitos
                      setModel(initialModel);
                      setRecordCount(0);
                      setShowTable(false);
                      setCurrentPage(1);
                      
                      console.log("✅ Importación completada exitosamente");
                      
                      // Recargar el header para refrescar la vista
                      console.log("🔄 Recargando header...");
                      await bindDataHeaderRemote();
                    } else {
                      toast({
                        type: "error",
                        message: "No se pudo procesar ningún registro. Revisa los errores."
                      });
                    }
                    
                  } catch (error) {
                    console.error("❌ Error general en el proceso de importación:", error);
                    toast({
                      type: "error",
                      message: `Error al procesar la importación: ${error.message || 'Error desconocido'}`
                    });
                  } finally {
                    setLoading(false);
                  }
                }}
                style={{ width: '120px' }}
              >
                Confirmar
              </button>
            </div>
          </div>
        );
      }
    });
  };

  //Update the field value on formik according to what has been updated
  const updateField = (fieldName, fieldValue) => {
    // Campos que deben estar en mayúsculas
    const upperCaseFields = ['Descripcion', 'Comentario'];
    
    // Si el campo está en la lista de mayúsculas, convertir el valor
    if (upperCaseFields.includes(fieldName) && typeof fieldValue === 'string') {
      formik.setFieldValue(fieldName, fieldValue.toUpperCase());
    } else {
      formik.setFieldValue(fieldName, fieldValue);
    }
  };

  // Función para subir archivos de la novedad
  const uploadNovedadFiles = async (idNovedad, guidNovedad) => {
    try {
      setUploadingFiles(true);
      
      // Filtrar solo archivos nuevos (no existentes)
      const newFiles = selectedFiles.filter(f => !f.isExisting);
      
      if (newFiles.length === 0) {
        console.log("📁 No hay archivos nuevos para subir");
        return true;
      }
      
      console.log(`📁 Subiendo ${newFiles.length} archivo(s) nuevos para IdNovedad: ${idNovedad}, GUID: ${guidNovedad}`);
      
      // Subir cada archivo individualmente
      for (let i = 0; i < newFiles.length; i++) {
        const fileData = newFiles[i];
        console.log(`📤 Subiendo archivo ${i + 1}/${newFiles.length}:`, fileData.file.name);
        
        // Crear FormData
        const formData = new FormData();
        formData.append('Token', user.Token);
        formData.append('IdUser', user.IdUser);
        formData.append('IdNovedad', idNovedad);
        formData.append('GUIDNovedad', guidNovedad); // Agregar GUID
        formData.append('Files', fileData.file);
        formData.append('Comentario', fileData.comentario || '');
        
        console.log(`📤 FormData enviado - IdNovedad: ${idNovedad}, GUIDNovedad: ${guidNovedad}`);
        
        // Hacer la petición POST con multipart/form-data
        const response = await AxiosInstance.post(
          'api/OcupacionProcesos/NovedadesDocumentosFiles',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        console.log(`✅ Archivo ${i + 1} subido:`, response.data);
      }
      
      console.log("✅ Todos los archivos nuevos subidos exitosamente");
      return true;
      
    } catch (error) {
      console.error("❌ Error al subir archivos:", error);
      toast({
        type: "error",
        message: "Error al subir algunos archivos"
      });
      return false;
    } finally {
      setUploadingFiles(false);
    }
  };

  // Función para actualizar/reemplazar archivos existentes
  const updateNovedadFiles = async (idNovedad, guidNovedad) => {
    try {
      setUploadingFiles(true);
      
      // Filtrar solo archivos marcados para actualizar (isReplacing = true)
      const filesToUpdate = selectedFiles.filter(f => f.isReplacing && f.isExisting);
      
      if (filesToUpdate.length === 0) {
        console.log("📁 No hay archivos para actualizar");
        return true;
      }
      
      console.log(`📁 Actualizando ${filesToUpdate.length} archivo(s) para IdNovedad: ${idNovedad}, GUID: ${guidNovedad}`);
      
      // Actualizar cada archivo individualmente
      for (let i = 0; i < filesToUpdate.length; i++) {
        const fileData = filesToUpdate[i];
        console.log(`🔄 Actualizando archivo ${i + 1}/${filesToUpdate.length}:`, fileData.originalFileName);
        
        // Crear FormData
        const formData = new FormData();
        formData.append('Token', user.Token);
        formData.append('IdUser', user.IdUser);
        formData.append('IdNovedad', idNovedad);
        formData.append('Files', fileData.newFile); // El nuevo archivo seleccionado
        formData.append('id', fileData.documentId); // ID del documento a actualizar
        formData.append('GUIDNovedad', guidNovedad);
        formData.append('Documento', fileData.originalFileName); // Nombre del documento original
        formData.append('Comentario', fileData.comentario || '');
        
        console.log(`🔄 FormData enviado - id: ${fileData.documentId}, Documento: ${fileData.originalFileName}`);
        
        // Hacer la petición PUT con multipart/form-data
        const response = await AxiosInstance.put(
          'api/OcupacionProcesos/NovedadesDocumentosFilesUpd',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        );
        
        console.log(`✅ Archivo ${i + 1} actualizado:`, response.data);
      }
      
      console.log("✅ Todos los archivos actualizados exitosamente");
      return true;
      
    } catch (error) {
      console.error("❌ Error al actualizar archivos:", error);
      toast({
        type: "error",
        message: "Error al actualizar algunos archivos"
      });
      return false;
    } finally {
      setUploadingFiles(false);
    }
  };


  const [validationsSchema, setValidationSchema] = useState(null);

  const fillFormikObject = (record) => {
    //debugger;
    console.log("record", record, "model", section);
    if (
      section &&
      fields &&
      fields.length > 0
    ) {
      fields.forEach((item) => {
        let fieldValue = record[item.FieldName];
        
        // Convertir fechas al formato dd/mm/yyyy para campos de tipo date o datetime
        if ((item.FieldType === 'date' || item.FieldType === 'datetime' || item.HtmlType === 'date') && fieldValue) {
          // Intentar convertir la fecha al formato dd/mm/yyyy
          const dateMoment = moment(fieldValue);
          if (dateMoment.isValid()) {
            fieldValue = dateMoment.format('DD/MM/YYYY');
          }
        }
        
        console.log(
          "field name",
          item.FieldName,
          "RecordValue ",
          fieldValue
        );
        formik.setFieldValue(item.FieldName, fieldValue);
      });
    }

    //Now
  };

  const prepareFormikObject = () => {
    // console.log("Preparing formik object", section)
    let initialObject = {};
    let initialObjectValidation = {};

    if (fields) {
      fields.forEach((item) => {
        initialObject[item.FieldName] = item.value;

        if (item.Required) {
          initialObjectValidation[item.FieldName] = yupTypeValidator(item);
        }
      });
    }
    formik.initialValues = initialObject;

    console.log("initialObject", initialObject)

    setValidationSchema(yup.object(initialObjectValidation));
    //Now
  };

  //This method is to save the record we are working on
  const handleSubmit = async (obj, event) => {
    console.log("❗ ~ file: CRUDSimple.js:259 ~ handleSubmit ~ obj:", obj)
    console.log({ fields: fields })
    let actions = {
      "I": "I",
      "U": "U",
      "D": "I"
    };

    if (actionMode === "D") {
      const { GUID, Id, ...rest } = obj;
      obj = rest;
    }


    const mensajeConfirmacion = "¿Confirma que desea guardar esta novedad?";
    
    confirmAlert({
      closeOnClickOutside: false,
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui text-center p-4" style={{ 
            backgroundColor: 'white', 
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            minWidth: '400px'
          }}>
            <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-cancel-hover"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "No" al backend con DialogText y DialogResp
                  // Preparar los datos para enviar
                  let objSPVersion = "";
                  fields.forEach((item) => {
                    if (item.ReadOnly || item.HtmlType === "separator") return;

                    if (item.HtmlType !== "separator") {
                      objSPVersion +=
                        (objSPVersion.length > 0 ? ", " : "") + `${item.FieldName}=`;
                    }
                    if (
                      item.FieldType === "int" ||
                      item.FieldType === "bool" ||
                      item.FieldType === "bit" ||
                      item.FieldType === "bigint"
                    ) {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                          : "'" + obj[item.FieldName] + "'";
                    } else if (item.HtmlType === "password") {
                      let passwordEncrypted = null;
                      if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                        passwordEncrypted =
                          obj["UserName"].toUpperCase() + obj[item.FieldName];
                        passwordEncrypted = Sha256.hash(passwordEncrypted);
                      }
                      objSPVersion +=
                        obj[item.FieldName] === undefined
                          ? "null"
                          : "'" + passwordEncrypted + "'"
                    } else if (item.HtmlType === 'radio') {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                          : "'" + obj[item.FieldName] + "'";
                    } else {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? "null"
                          : "'" + obj[item.FieldName] + "'";
                    }
                  });

                  let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=No`;
                  let queryData = {
                    Data: objSPVersion,
                  };

                  let prefix = idModule ? "CRUDDynamic" : "CRUD";
                  await API.postAction(
                    `api/${prefix}/AddEdit?${queryString}`,
                    queryData
                  );
                }}
                style={{ width: '120px' }}
              >
                Cancelar
              </button>
              <button
                className="btn btn-success"
                onClick={async () => {
                  onClose();
                  // Enviar respuesta "Si" al backend con DialogText y DialogResp
                  let objSPVersion = "";
                  fields.forEach((item) => {
                    if (item.ReadOnly || item.HtmlType === "separator") return;

                    if (item.HtmlType !== "separator") {
                      objSPVersion +=
                        (objSPVersion.length > 0 ? ", " : "") + `${item.FieldName}=`;
                    }
                    if (
                      item.FieldType === "int" ||
                      item.FieldType === "bool" ||
                      item.FieldType === "bit" ||
                      item.FieldType === "bigint"
                    ) {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                          : "'" + obj[item.FieldName] + "'";
                    } else if (item.HtmlType === "password") {
                      let passwordEncrypted = null;
                      if (obj[item.FieldName] && obj[item.FieldName].length > 0) {
                        passwordEncrypted =
                          obj["UserName"].toUpperCase() + obj[item.FieldName];
                        passwordEncrypted = Sha256.hash(passwordEncrypted);
                      }
                      objSPVersion +=
                        obj[item.FieldName] === undefined
                          ? "null"
                          : "'" + passwordEncrypted + "'"
                    } else if (item.HtmlType === 'radio') {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? item.DefaultValue && item.DefaultValue.length > 0 ? item.DefaultValue : "null"
                          : "'" + obj[item.FieldName] + "'";
                    } else {
                      objSPVersion +=
                        obj[item.FieldName] === undefined || obj[item.FieldName] === null
                          ? "null"
                          : "'" + obj[item.FieldName] + "'";
                    }
                  });

                  let queryString = `IdUser=${user.IdUser}&Id=${params.id}&Token=${user.Token}&ActionMode=${actions[actionMode]}${idModule ? "&IdModule=" + idModule : ""}&DialogText=${encodeURIComponent(mensajeConfirmacion)}&DialogResp=Si`;
                  let queryData = {
                    Data: objSPVersion,
                  };

                  let prefix = idModule ? "CRUDDynamic" : "CRUD";
                  let request = await API.postAction(
                    `api/${prefix}/AddEdit?${queryString}`,
                    queryData
                  );

                  if (request.status === 200) {
                    let response = JSON.parse(request.data[0].JSONData)[0];
                    if (response && (response.Error || response.Logout || response.Expired)) {
                      if (handleApiResponse(response)) {
                        return;
                      }
                    }
                    
                    console.log("📋 Response completo del servidor:", response);
                    
                    // Extraer el ID y GUID de la novedad (creada o actualizada) desde la respuesta
                    let idNovedad = null;
                    let guidNovedad = null;
                    
                    // En modo Update, usar el ID y GUID del objeto que viene del formulario
                    if (actionMode === "U") {
                      // Prioridad: obj (formik) > selectedItem > response
                      idNovedad = obj.Id || selectedItem?.Id || response.JSONData?.Id || response.Id || null;
                      guidNovedad = obj.GUID || selectedItem?.GUID || response.JSONData?.GUID || response.GUID || null;
                      console.log("📋 Modo Update - usando obj/selectedItem:", { 
                        idNovedad, 
                        guidNovedad,
                        fromObj: { Id: obj.Id, GUID: obj.GUID },
                        fromSelectedItem: { Id: selectedItem?.Id, GUID: selectedItem?.GUID }
                      });
                    } 
                    // En modo Insert, obtener el ID y GUID desde la respuesta
                    else {
                      // Intentar múltiples formas de obtener el ID
                      idNovedad = response.JSONData?.Id || response.Id || null;
                      
                      // Intentar múltiples formas de obtener el GUID
                      guidNovedad = response.JSONData?.GUID || 
                                    response.GUID || 
                                    response.JSONData?.Guid ||
                                    response.Guid ||
                                    null;
                      
                      console.log("📋 Modo Insert - desde response:", { 
                        idNovedad, 
                        guidNovedad,
                        responseJSONData: response.JSONData 
                      });
                    }
                    
                    console.log(`✅ ${actionMode === "U" ? "Novedad actualizada" : "Novedad creada"} con ID:`, idNovedad, "GUID:", guidNovedad);
                    
                    // Debug: Verificar el estado de selectedFiles antes de filtrar
                    console.log("🔍 selectedFiles ANTES de filtrar:", selectedFiles.map(f => ({
                      name: f.file?.name,
                      isExisting: f.isExisting,
                      isReplacing: f.isReplacing,
                      documentId: f.documentId
                    })));
                    
                    // Filtrar archivos nuevos y archivos para actualizar
                    const newFilesToUpload = selectedFiles.filter(f => !f.isExisting && !f.isReplacing);
                    const filesToUpdate = selectedFiles.filter(f => f.isReplacing && f.isExisting);
                    
                    console.log("📊 Estado de archivos:", {
                      totalFiles: selectedFiles.length,
                      newFiles: newFilesToUpload.length,
                      filesToUpdate: filesToUpdate.length,
                      selectedFiles: selectedFiles.map(f => ({
                        name: f.file.name,
                        isExisting: f.isExisting,
                        isReplacing: f.isReplacing
                      }))
                    });
                    
                    // Subir archivos nuevos si hay alguno seleccionado
                    if (newFilesToUpload.length > 0 && idNovedad && guidNovedad) {
                      console.log(`📁 Subiendo ${newFilesToUpload.length} archivo(s) nuevo(s)...`);
                      await uploadNovedadFiles(idNovedad, guidNovedad);
                    } else {
                      console.log("⏭️ Sin archivos nuevos para subir", { 
                        hasFiles: newFilesToUpload.length > 0, 
                        hasId: !!idNovedad, 
                        hasGuid: !!guidNovedad 
                      });
                    }
                    
                    // Actualizar archivos existentes si hay alguno marcado para reemplazar
                    if (filesToUpdate.length > 0 && idNovedad && guidNovedad) {
                      console.log(`🔄 Actualizando ${filesToUpdate.length} archivo(s) existente(s)...`);
                      await updateNovedadFiles(idNovedad, guidNovedad);
                    } else {
                      console.log("⏭️ Sin archivos para actualizar", { 
                        hasFiles: filesToUpdate.length > 0, 
                        hasId: !!idNovedad, 
                        hasGuid: !!guidNovedad 
                      });
                    }
                  }


                  setGeneralError(null);
                  setSelectedItem(null);

                  formik.resetForm();

                  // Contar archivos nuevos y actualizados
                  const newFilesCount = selectedFiles.filter(f => !f.isExisting && !f.isReplacing).length;
                  const updatedFilesCount = selectedFiles.filter(f => f.isReplacing && f.isExisting).length;
                  
                  // Construir mensaje según los archivos procesados
                  let message = "Registro guardado correctamente";
                  if (newFilesCount > 0 && updatedFilesCount > 0) {
                    message = `Registro guardado, ${newFilesCount} archivo(s) nuevo(s) subido(s) y ${updatedFilesCount} archivo(s) actualizado(s) exitosamente`;
                  } else if (newFilesCount > 0) {
                    message = `Registro guardado y ${newFilesCount} archivo(s) nuevo(s) subido(s) exitosamente`;
                  } else if (updatedFilesCount > 0) {
                    message = `Registro guardado y ${updatedFilesCount} archivo(s) actualizado(s) exitosamente`;
                  }
                  
                  toast({
                    type: "success",
                    message: message
                  });
                  
                  // Limpiar archivos
                  setSelectedFiles([]);
                  
                  toggleOpen(null, true);
                }}
                style={{ width: '120px' }}
              >
                Confirmar
              </button>
            </div>
          </div>
        );
      }
    });


  };

  const formik = useFormik({
    initialValues: {},
    enableReinitialize: true,

    validateOnChange: false,
    validateOnBlur: false,

    validationSchema: validationsSchema,
    onSubmit: handleSubmit,
  });

  const addFavorite = async () => {

    const newFavorite = {
      icon: `${section.FormIcon}`,
      path: pathname,
      formPath: section.FormPath,
      title: section.FormTitle,
    }
    UpdateFavorites(newFavorite)

  }

  const headerWithoutAuditFields = () => {
    const headers = tableHeader && tableHeader
      .filter(x =>
        x.FieldTitle !== "Audit Information"
        && x.FieldName !== "IdUserAdd"
        && x.FieldName !== 'DateAdd'
        && x.FieldName !== 'IdUserMod'
        && x.FieldName !== 'DateMod'
        && x.FieldName !== 'GUID' // Ocultar columna GUID
        
      
      )
    console.log("📋 headerWithoutAuditFields:", headers?.length, "campos visibles");
    return headers || []; // Asegurar que siempre devuelva un array
  }

  // Función para exportar headers a Excel (plantilla vacía)
  const exportHeadersToExcel = () => {
    const visibleColumns = headerWithoutAuditFields();
    
    if (!visibleColumns || visibleColumns.length === 0) {
      toast({
        type: "warning",
        message: "No hay columnas disponibles para exportar"
      });
      return;
    }
    
    // Filtrar la columna Id para el Excel (se llena automáticamente al cargar)
    const columnsForExcel = visibleColumns.filter(column => column.FieldName !== 'Id');
    
    // Crear un objeto vacío con solo los headers como propiedades
    const emptyRow = {};
    columnsForExcel.forEach(column => {
      emptyRow[column.FieldName] = '';
    });
    
    // Crear un array con una fila vacía para que el Excel tenga los headers
    const excelData = [emptyRow];
    
    GenerateXLS(excelData, `Plantilla_${section?.FormTitle || 'Importacion'}`);
    
    toast({
      type: "success",
      message: "Plantilla de Excel descargada exitosamente"
    });
    
    console.log("📥 Plantilla exportada con columnas:", columnsForExcel.map(c => c.FieldName));
  };

  // Función para procesar el archivo Excel
  const processExcelFile = (file) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: 'binary' });
        
        // Obtener la primera hoja
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        
        // Convertir a JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        
        if (jsonData.length === 0) {
          toast({
            type: "warning",
            message: "El archivo Excel está vacío"
          });
          return;
        }
        
        // La primera fila son los headers del Excel
        const excelHeaders = jsonData[0];
        const excelRows = jsonData.slice(1);
        
        console.log("📋 Headers del Excel:", excelHeaders);
        console.log("📋 Headers de la tabla:", tableHeader.map(h => h.FieldName));
        
        // Crear mapeo entre columnas del Excel y la tabla
        const columnMapping = {};
        const tableHeaders = headerWithoutAuditFields();
        
        excelHeaders.forEach((excelCol, index) => {
          // Buscar coincidencia exacta por FieldName o FieldTitle
          const matchedHeader = tableHeaders.find(
            h => h.FieldName.toLowerCase() === excelCol.toLowerCase() || 
                 h.FieldTitle.toLowerCase() === excelCol.toLowerCase()
          );
          
          if (matchedHeader) {
            columnMapping[index] = matchedHeader.FieldName;
            console.log(`✅ Columna mapeada: "${excelCol}" -> "${matchedHeader.FieldName}"`);
          } else {
            console.log(`⚠️ Columna no mapeada: "${excelCol}"`);
          }
        });
        
        // Procesar las filas
        const mappedRows = excelRows
          .filter(row => row && row.length > 0 && row.some(cell => cell !== null && cell !== undefined && cell !== '')) // Filtrar filas vacías
          .map((row, rowIndex) => {
            const mappedRow = {};
            
            // Agregar Id secuencial automáticamente
            mappedRow['Id'] = rowIndex + 1;
            
            // Mapear cada celda según el columnMapping
            Object.keys(columnMapping).forEach(excelIndex => {
              const fieldName = columnMapping[excelIndex];
              const value = row[excelIndex];
              
              // Buscar el header para obtener el tipo de campo
              const header = tableHeaders.find(h => h.FieldName === fieldName);
              
              if (header) {
                // Procesar según el tipo de campo
                if (header.FieldType === 'date' || header.FieldType === 'datetime') {
                  // Manejar fechas de Excel
                  if (value !== null && value !== undefined && value !== '') {
                    // Si es un número, Excel lo guarda como serial number
                    if (typeof value === 'number') {
                      // Convertir el número serial de Excel a fecha
                      const excelEpoch = new Date(1899, 11, 30); // Excel epoch
                      const date = new Date(excelEpoch.getTime() + value * 86400000);
                      mappedRow[fieldName] = moment(date).format('YYYY-MM-DD');
                      console.log(`📅 Fecha convertida: ${value} -> ${mappedRow[fieldName]}`);
                    } 
                    // Si es un string, intentar parsearlo
                    else if (typeof value === 'string') {
                      // Intentar diferentes formatos comunes
                      let parsedDate = moment(value, ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'], true);
                      if (parsedDate.isValid()) {
                        mappedRow[fieldName] = parsedDate.format('YYYY-MM-DD');
                        console.log(`📅 Fecha parseada: "${value}" -> ${mappedRow[fieldName]}`);
                      } else {
                        console.warn(`⚠️ No se pudo parsear la fecha: "${value}"`);
                        mappedRow[fieldName] = '';
                      }
                    }
                    // Si ya es un objeto Date
                    else if (value instanceof Date) {
                      mappedRow[fieldName] = moment(value).format('YYYY-MM-DD');
                      console.log(`📅 Fecha desde Date object: ${mappedRow[fieldName]}`);
                    }
                    else {
                      mappedRow[fieldName] = '';
                    }
                  } else {
                    mappedRow[fieldName] = ''; // Dejar vacío si no hay fecha
                  }
                } else if (header.FieldType === 'int' || header.FieldType === 'float' || header.FieldType === 'decimal') {
                  mappedRow[fieldName] = value ? Number(value) : null;
                } else if (header.FieldType === 'bit' || header.FieldType === 'boolean') {
                  mappedRow[fieldName] = value === 'true' || value === '1' || value === 1 || value === true;
                } else {
                  mappedRow[fieldName] = value || '';
                }
              }
            });
            
            return mappedRow;
          });
        
        console.log("✅ Datos procesados:", mappedRows);
        console.log(`📊 Total de filas cargadas: ${mappedRows.length}`);
        
        // Actualizar el modelo con los datos procesados
        setModel({
          ...model,
          data: {
            Columns: tableHeaders.map(h => h.FieldName),
            Rows: mappedRows
          }
        });
        
        // Actualizar el conteo de registros
        setRecordCount(mappedRows.length);
        setShowTable(true);
        
        toast({
          type: "success",
          message: `Se cargaron ${mappedRows.length} registros desde el archivo Excel exitosamente`
        });
        
      } catch (error) {
        console.error("❌ Error al procesar el archivo Excel:", error);
        toast({
          type: "error",
          message: "Error al procesar el archivo Excel. Por favor, verifica el formato del archivo."
        });
      }
    };
    
    reader.onerror = (error) => {
      console.error("❌ Error al leer el archivo:", error);
      toast({
        type: "error",
        message: "Error al leer el archivo. Por favor, intenta nuevamente."
      });
    };
    
    reader.readAsBinaryString(file);
  };

  // Modified by Frandy para exportar solo las columnas visibles
  const exportToExcel = useCallback(async () => {

    const visibleColumns = headerWithoutAuditFields();
    
    const excelData = model.data.Rows && model.data.Rows.map((item) => {
      return visibleColumns.reduce((acc, column) => {
        acc[column.FieldName] = item[column.FieldName];
        return acc;
      }, {});

    });
  
    GenerateXLS(excelData, `${section.FormTitle}.xlsx`);

  }, [model.data.Rows, tableHeader, section]);

  const exportToPDF = useCallback(async () => {
    const container = document.getElementById("contentContainer");
    if (container) {
      await GeneratePDF(container, "landscape", section?.FormTitle || "Registro");
    } else {
      console.error("No se encontró el contenedor para exportar a PDF");
      toast({
        type: "error",
        message: "Error: No se puede exportar el contenido. Elemento no encontrado."
      });
    }
    // GeneratePDF(container);
  }, [section, toast])

  // Add by Victor: Agrega el handlePrint para imprimir el contenido de la pantalla
  const handlePrint = useCallback(() => {
    // Crear el HTML de la tabla
    const visibleColumns = headerWithoutAuditFields();
    
    let tableHTML = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${section?.FormTitle || 'Tabla'}</title>
          <style>
            @media print {
              @page {
                margin: 1cm;
                size: landscape;
              }
            }
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            h4 {
              text-align: center;
              font-weight: bold;
              margin-bottom: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              border: 1px solid #000;
            }
            th {
              background-color: #6c757d;
              color: white;
              font-weight: bold;
              padding: 8px;
              border: 1px solid #000;
              text-align: left;
            }
            td {
              padding: 8px;
              border: 1px solid #000;
            }
            tr:nth-child(even) {
              background-color: #f2f2f2;
            }
          </style>
        </head>
        <body>
          <h4>${section?.FormTitle || 'Tabla'}</h4>
          <table>
            <thead>
              <tr>
                ${visibleColumns.map(column => `<th>${column.FieldTitle}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${model?.data?.Rows?.map((item) => {
                return `<tr>
                  ${visibleColumns.map((column) => {
                    let cellValue = '';
                    if (column.FieldType === "datetime" || column.FieldType === "date") {
                      const dateValue = item[column.FieldName];
                      if (dateValue && dateValue !== '' && moment(dateValue).isValid()) {
                        cellValue = moment(dateValue).format("MM/DD/YYYY");
                      } else {
                        cellValue = '';
                      }
                    } else if (typeof item[column.FieldName] === 'boolean') {
                      cellValue = item[column.FieldName] ? 'Sí' : 'No';
                    } else {
                      cellValue = item[column.FieldName] || '';
                    }
                    return `<td>${cellValue}</td>`;
                  }).join('')}
                </tr>`;
              }).join('') || ''}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Crear una nueva ventana y escribir el HTML
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(tableHTML);
      printWindow.document.close();
      
      // Esperar a que se cargue el contenido y luego imprimir
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.print();
          // Cerrar la ventana después de imprimir (opcional)
          // printWindow.close();
        }, 250);
      };
    }
  }, [model?.data?.Rows, tableHeader, section])

  // END METHODS

  // UI METHODS

  useEffect(() => {
    console.log("entro", new Date())
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      // bindDataRemote(); // DESACTIVADO
    }
  }, [sortBy, sortByOrder])

  // useEffect para detectar cambios en filterValues y hacer fetch automático
  useEffect(() => {
    // Solo ejecutar si hay filtros y no están cargando
    if (!loadingFilters && filters.length > 0 && Object.keys(filterValues).length > 0) {
      console.log("🔄 Cambio en filterValues detectado, haciendo fetch...", filterValues);
      const timeoutId = setTimeout(async () => {
        // await bindDataRemote(); // DESACTIVADO
        // await bindDataCountRemote(); // DESACTIVADO
        setShowTable(true); // Mostrar la tabla después de la primera carga
      }, 300); // Debounce de 300ms para evitar múltiples llamadas
      
      return () => clearTimeout(timeoutId);
    }
  }, [filterValues, loadingFilters])

  const loadGRIDUI = () => {
    return (
      <>
        {/* Filtros dinámicos con Card y background azul */}
       
     

        {/* Botones para manejo de Excel - Fuera del Card */}
        <div className="mb-3 mx-2 text-start">
          <div className="d-flex gap-2">
            {/* Botón para descargar plantilla de Excel */}
            <Button 
              variant="success" 
              className="d-flex align-items-center justify-content-center gap-2"
              onClick={exportHeadersToExcel}
            >
              <i className="fa-solid fa-file-excel" style={{ fontSize: "1.2rem" }}></i>
              Generar Plantilla
            </Button>

            {/* Botón para cargar archivos de Excel */}
            <Button 
              variant="success" 
              className="d-flex align-items-center justify-content-center gap-2"
              onClick={() => {
                document.getElementById('excel-file-input')?.click();
              }}
            >
              <i className="fa-solid fa-file-arrow-down" style={{ fontSize: "1.2rem" }}></i>
              Cargar Archivo
            </Button>

            {/* Botón para procesar importación - Solo visible cuando hay datos cargados */}
            {showTable && model?.data?.Rows && model.data.Rows.length > 0 && (
              <Button 
                variant="primary" 
                className="d-flex align-items-center justify-content-center gap-2"
                onClick={processImportation}
                disabled={loading}
              >
                <i className="fa-solid fa-download" style={{ fontSize: "1.2rem" }}></i>
                {loading ? 'Procesando...' : `Procesar Importación (${model.data.Rows.length})`}
              </Button>
            )}



          </div>

          <input
            id="excel-file-input"
            type="file"
            accept=".xlsx,.xls"
            multiple={false}
            style={{ display: 'none' }}
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                console.log('📂 Archivo seleccionado:', file.name);
                processExcelFile(file);
                // Limpiar el input para permitir cargar el mismo archivo nuevamente
                e.target.value = '';
              }
            }}
          />
        </div>

        {/* Tabla - Solo se muestra después de consultar */}
        {showTable && (
        <Container fluid>
          <Row className="mx-2">
            <div className="table-responsive" style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <Table hover size="xl" bordered className="border shadow-sm" style={{ minWidth: '1200px' }}>
              <thead className="table-secondary">
                <tr>
                  {/* HEADERS TABLA */}
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      return (
                        <th key={index} className={`fw-bold`}>
                          {item.ListTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {getCurrentPageData().map((item, index) => {

                  // Determinar si esta fila debe estar activa usando Id
                  const isActive = selectedItem?.Id === item.Id;
                  
                  return (
                    <tr 
                      key={item.Id || index} 
                      onClick={() => { 
                        console.log('✅ Click en fila - Id:', item.Id, 'Item completo:', item);
                        console.log('📌 selectedItem antes:', selectedItem);
                        setSelectedItem(item);
                        console.log('📌 selectedItem después (será:', item.Id, ')');
                      }} 
                      className={isActive ? "active" : ""}
                      style={{ cursor: 'pointer' }}
                    >
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            const dateValue = item[column.FieldName];
                            const formattedDate = (dateValue && dateValue !== '' && moment(dateValue).isValid()) 
                              ? moment(dateValue).format("MM/DD/YYYY") 
                              : '';
                            return (
                              <td key={index2} className={` `}>{formattedDate}</td>
                            )
                          }

                          // Detectar si la columna contiene iconos en formato JSON
                          const cellValue = item[column.FieldName];
                          let parsedIcons = null;
                          
                          // Intentar parsear si es un string que parece JSON de iconos
                          if (typeof cellValue === 'string' && cellValue.trim().startsWith('[')) {
                            try {
                              parsedIcons = JSON.parse(cellValue);
                            } catch (e) {
                              console.warn(`⚠️ No se pudo parsear JSON en columna ${column.FieldName}:`, cellValue, e);
                            }
                          }
                          
                          // Si logramos parsear un array de iconos estructurados
                          if (Array.isArray(parsedIcons) && parsedIcons.length > 0 && parsedIcons[0].icon) {
                            console.log(`🎨 Renderizando ${parsedIcons.length} iconos para ${column.FieldName}`);
                            return (
                              <td key={index2} style={{ textAlign: 'center' }}>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                  {parsedIcons.map((iconObj, iconIdx) => {
                                    const isDisabled = iconObj.Enabled === "false" || iconObj.Enabled === false;
                                    const iconClass = iconObj.icon;
                                    const isEditarIcon = iconObj.function === 'Editar' || iconObj.Name === 'Editar';
                                    const isEliminarIcon = iconObj.function === 'Eliminar' || iconObj.Name === 'Eliminar';
                                    const isVisualizarIcon = iconObj.function === 'Visualizar' || iconObj.Name === 'Visualizar';
                                    const isImprimirIcon = iconObj.function === 'Imprimir' || iconObj.Name === 'Imprimir';
                                    
                                    return (
                                      <button
                                        key={iconIdx}
                                        className={`btn btn-sm`}
                                        title={iconObj.Name || iconObj.function}
                                        disabled={isDisabled || loading}
                                        onClick={async (e) => {
                                          e.stopPropagation(); // Evitar que se seleccione la fila
                                          
                                          // Establecer el item actual como seleccionado
                                          setSelectedItem(item);
                                          
                                          // Ejecutar la acción correspondiente pasando el item directamente
                                          if (isEditarIcon) {
                                            await toggleOpen("U", false, item);
                                          } else if (isEliminarIcon) {
                                            // Para eliminar también necesitamos el item
                                            deleteConfirm();
                                          } else if (isVisualizarIcon) {
                                            await toggleOpen("C", false, item);
                                          } else if (isImprimirIcon) {
                                            // Ejecutar impresión y abrir PDF
                                            await handlePrintReport(item);
                                          }
                                        }}
                                        style={{
                                          opacity: isDisabled ? 0.5 : 1,
                                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                                          padding: '0.25rem 0.5rem',
                                          border: 'none',
                                          background: 'transparent'
                                        }}
                                      >
                                        <i className={iconClass} style={{ fontSize: '1.2rem' }}></i>
                                      </button>
                                    );
                                  })}
                                </div>
                              </td>
                            );
                          }

                          return (
                            <td key={index2} className={` `}>{
                              (typeof item[column.FieldName] === 'boolean') ? <input type="checkbox" checked={item[column.FieldName]} className="" readOnly /> : item[column.FieldName]
                            }</td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<div className="d-flex align-items-center gap-3 pt-2">
                <p className="m-0 fw-bold">Total de registros:</p>
                <span 
                  className="badge border border-black d-flex align-items-center justify-content-center" 
                  style={{ 
                    fontSize: '0.875rem', 
                    height: '25px',
                    minWidth: '70px',
                    padding: '0.25rem 0.5rem', 
                    backgroundColor: '#ffffff', 
                    color: '#495057' 
                  }}
                >
                  {recordCount.toLocaleString('en-US')}
                </span>
                <p className="m-0">Registros por página:</p>
                <div>
                  <select
                      className="form-select form-select-sm"
                      value={RecordsQuantity}
                      onChange={(e) => {
                        console.log("selected value", e.target.value)
                        const newQuantity = parseInt(e.target.value);
                        if (newQuantity < 1) {
                          setRecordsQuantity(0);
                        } else {
                          setRecordsQuantity(newQuantity)
                        }
                        setCurrentPage(1)
                      }}
                    >
                      {allowedPageSizes.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.text}
                          </option>
                        );
                      }
                      )}
                    </select>
                </div>
              </div>)}
              {(model?.data?.Columns && model?.data?.Rows.length > 0) && (<Pagination className="my-0 pt-2">
                <Pagination.First disabled={loading} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage <= 1 || loading} />
                
                {/* Lógica de paginación dinámica - Muestra 5 páginas */}
                {(() => {
                  const pages = [];
                  let startPage, endPage;
                  
                  if (totalPages <= 5) {
                    // Si hay 5 páginas o menos, mostrar todas
                    startPage = 1;
                    endPage = totalPages;
                  } else {
                    // Si hay más de 5 páginas
                    if (currentPage <= 3) {
                      // Al inicio: mostrar 1, 2, 3, 4, 5
                      startPage = 1;
                      endPage = 5;
                    } else if (currentPage >= totalPages - 2) {
                      // Al final: mostrar las últimas 5
                      startPage = totalPages - 4;
                      endPage = totalPages;
                    } else {
                      // En el medio: mostrar 2 antes y 2 después de la actual
                      startPage = currentPage - 2;
                      endPage = currentPage + 2;
                    }
                  }
                  
                  // Mostrar ellipsis al inicio si es necesario
                  if (startPage > 1) {
                    pages.push(
                      <Pagination.Item 
                        key={1}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(1)}
                      >
                        1
                      </Pagination.Item>
                    );
                    if (startPage > 2) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
                    }
                  }
                  
                  // Mostrar las páginas del rango
                  for (let i = startPage; i <= endPage; i++) {
                    pages.push(
                      <Pagination.Item 
                        key={i}
                        disabled={loading} 
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                  
                  // Mostrar ellipsis al final si es necesario
                  if (endPage < totalPages) {
                    if (endPage < totalPages - 1) {
                      pages.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
                    }
                    pages.push(
                      <Pagination.Item 
                        key={totalPages}
                        disabled={loading} 
                        active={false}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                  
                  return pages;
                })()}
                
                <Pagination.Next disabled={currentPage >= totalPages || loading} onClick={() => setCurrentPage(currentPage + 1)} />
                <Pagination.Last disabled={loading} onClick={() => setCurrentPage(totalPages)} />
              </Pagination>)}
            </div>
            {/* {console.log("Current Page", currentPage, "Total Pages", totalPages)} */}
          </Row>
        </Container>
        )}

        {/* Add by Victor: Agrega la maquetacion del formato en PDF */}
        <Container id="contentContainer" style={{ 
            position: 'absolute', 
            left: '-9999px', 
            top: 0,
            width: '100%' // Ancho fijo para el PDF
          }}>
          <div className="mb-4 text-center">
            <img src={logoSignos} alt="Signos Framework" width={400} />
            <h3 className="fw-bold">Signos Framework SRL</h3>
            <p>Ave. Rómulo Betancourt, Esq. Dr. Fernando A. Defilló, No. 1428 · Sector Bella Vista · Santo Domingo, República Dominicana.</p>
            <p>RNC: 1234567890</p>
            <p>Fecha: {moment().format("DD/MM/YYYY")}</p>
          </div>
          <Row className="mx-2">
            <h4 className="text-center fw-bold">{section.FormTitle}</h4>

            <Table hover size="xl" bordered className="border shadow-sm" >
              <thead className="table-secondary">
                <tr>
                  {headerWithoutAuditFields()
                    .map((item, index) => {
                      return (
                        <th key={index} className={`fw-bold`}>
                          {item.FieldTitle}
                        </th>
                      )
                    })}
                </tr>
              </thead>
              <tbody>
                {model?.data && model.data.Rows.map((item, index) => {
                  return (
                    <tr key={index}>
                      {headerWithoutAuditFields()
                        .map((column, index2) => {
                          if (column.FieldType === "datetime" || column.FieldType === "date") {
                            const dateValue = item[column.FieldName];
                            const formattedDate = (dateValue && dateValue !== '' && moment(dateValue).isValid()) 
                              ? moment(dateValue).format("MM/DD/YYYY") 
                              : '';
                            return (
                              <td key={index2}>{formattedDate}</td>
                            )
                          }

                          return (
                            <td key={index2}>
                              {(typeof item[column.FieldName] === 'boolean') ? 
                                (item[column.FieldName] ? 'Sí' : 'No') : 
                                item[column.FieldName]
                              }
                            </td>
                          )
                        })}
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          </Row>
        </Container>
      </>
    );
  };

  //EVENTS


  useEffect(() => {
    setOpen(false)
    setSelectedItem(null)
    setActionMode(null)
    setGeneralError(null)
    setModel(initialModel);
    checkIfPinned();
    setSearch("");
    setColumnFilters({});
    setShowTable(false); // Ocultar tabla hasta que se carguen los filtros y datos
    setLoadingFilters(true); // Iniciar carga de filtros
    bindDataModelRemote();
    bindDataHeaderRemote(); // Esto cargará los filtros y inicializará filterValues
    setCurrentPage(1);
    // bindDataRemote() se ejecutará automáticamente cuando filterValues se actualice // YA NO SE USA

    return () => formik.resetForm();
  }, [params.id]);

  useEffect(() => {

    console.log("section updated", model)
    prepareFormikObject();
  }, [section, fields]);
  // END EVENTS
  useEffect(() => {
    console.log("entro record quantity")
    // Solo ejecutar si ya hay filterValues cargados
    if (!loadingFilters && Object.keys(filterValues).length > 0) {
      // bindDataRemote(); // DESACTIVADO
    }
  }, [RecordsQuantity])

  useEffect(() => {
    console.log("Record Count", recordCount, "Records Quantity", RecordsQuantity);
    console.log("Pages", Math.ceil(recordCount / RecordsQuantity))
    setTotalPages(Math.ceil(recordCount / RecordsQuantity))
  }, [recordCount, RecordsQuantity])
  
  // Limpiar URLs de preview cuando el componente se desmonte (solo locales)
  useEffect(() => {
    return () => {
      selectedFiles.forEach(fileData => {
        if (fileData.previewUrl && !fileData.isExisting) {
          URL.revokeObjectURL(fileData.previewUrl);
        }
      });
    };
  }, [selectedFiles])

  // Control de teclado para el visor de archivos
  useEffect(() => {
    if (!viewerOpen) return;
    
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        closeFileViewer();
      } else if (e.key === 'ArrowLeft') {
        goToPreviousFile();
      } else if (e.key === 'ArrowRight') {
        goToNextFile();
      }
    };
    
    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [viewerOpen, selectedFiles.length])
  
  // Renderizar ErrorModal incluso si section es null
  if (!section) {
    return <ErrorModal />
  }
  
  return (
    <React.Fragment>
      <style>{`
        .file-preview:hover .file-preview-icon {
          opacity: 1 !important;
        }
        /* Campos que deben mostrar texto en mayúsculas instantáneamente */
        input[name="Descripcion"],
        textarea[name="Descripcion"],
        input[name="Comentario"],
        textarea[name="Comentario"],
        .dx-texteditor-input[name="Descripcion"],
        .dx-texteditor-input[name="Comentario"] {
          text-transform: uppercase !important;
        }
      `}</style>
      {open ?
        <Modal
          show={open}
          onHide={() => {
            // Limpiar URLs de preview (solo los locales)
            selectedFiles.forEach(fileData => {
              if (fileData.previewUrl && !fileData.isExisting) {
                URL.revokeObjectURL(fileData.previewUrl);
              }
            });
            setSelectedFiles([]); // Limpiar archivos
            toggleOpen(null);
          }}
          backdrop="static"
          keyboard={false}
          dialogClassName="modal-fullwidth-custom"
          className="modalRight"
        
        >
          <Modal.Header closeButton>
            <Modal.Title className="d-flex align-items-center w-100">
              <span>{section.FormTitle}</span>
              
              {/* Botones de navegación - solo en modo Consultar */}
              {actionMode === "C" && selectedItem && (
                <div className="ms-auto d-flex gap-2 align-items-center me-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={navigateToPreviousRecord}
                    disabled={!hasPreviousRecord()}
                    title="Registro anterior"
                  >
                    <i className="fa fa-chevron-left"></i> Anterior
                  </button>
                  
                  <span className="d-flex align-items-center px-2 text-muted small">
                    {getCurrentPageData().findIndex(item => item.Id === selectedItem?.Id) + 1} / {getCurrentPageData().length}
                  </span>
                  
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={navigateToNextRecord}
                    disabled={!hasNextRecord()}
                    title="Registro siguiente"
                  >
                    Siguiente <i className="fa fa-chevron-right"></i>
                  </button>
                </div>
              )}
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              <Row>
                {/* CONTENT */}

                <label className="me-2 separatorTitle">Datos de la novedad</label>
                <hr className="separatorLine" />
                
                {
                  fields.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col
                          className={
                            item.cssClasss + (!item.Visible ? " d-none" : "")
                          }
                          key={index}
                        >
                          <label className={item.HtmlType === 'separator' ? `me-2 ${(index !== 0 ? "mt-4 pt-4" : "mt-2")}  separatorTitle` : "me-2 mt-3 "}>{item.FieldTitle}
                            {item.Required ? <i className="required-asterisk ms-1 text-danger">*</i> : null}
                          </label>
                          <br />

                          <FieldSelector
                            actionMode={actionMode}
                            model={item}
                            key={`${item.FieldName}-${selectedItem?.Id || 'new'}`}
                            obj={formik.values}
                            // limit longitudes
                            updateField={updateField}
                            value={formik.values[item.FieldName]}
                          ></FieldSelector>
                          {formik.errors[item.FieldName] ? (
                            <div className="invalid text-sm">
                              {formik.errors[item.FieldName]}
                            </div>
                          ) : null}
                        </Col>
                      </React.Fragment>
                    );
                  })}
              </Row>

              {/* Modified by Frandy para mostrar los errores de los campos */}

               {/*
              
                {Object.values(formik.errors).length > 0 && Object.values(formik.errors).map(item => {

                  return <Row className="invalid me-2 ">{item}</Row>
                })}
            
              */}

              {/* Sección de subida de archivos */}
              {(actionMode === "I" || actionMode === "U" || actionMode === "C") && (
                <Row className="mt-4">
                  <Col md={12}>
                 
                    
                    {actionMode !== "C" && (
                      <div className="mb-3">
                        <input
                          type="file"
                          multiple
                          accept="image/*,.pdf,video/*"
                          id="fileInput"
                          style={{ display: 'none' }}
                          onChange={(e) => {
                          const files = Array.from(e.target.files);
                          
                          // Validar que solo sean imágenes, PDF o videos
                          const validFiles = files.filter(file => {
                            const isImage = file.type.startsWith('image/');
                            const isPDF = file.type === 'application/pdf';
                            const isVideo = file.type.startsWith('video/');
                            return isImage || isPDF || isVideo;
                          });
                          
                          if (validFiles.length !== files.length) {
                            toast({
                              type: "warning",
                              message: "Solo se permiten archivos de imagen, PDF o video"
                            });
                          }
                          
                          const newFiles = validFiles.map(file => {
                            const isImage = file.type.startsWith('image/');
                            const isVideo = file.type.startsWith('video/');
                            const isPDF = file.type === 'application/pdf';
                            const previewUrl = (isImage || isVideo) ? URL.createObjectURL(file) : null;
                            
                            return {
                              file,
                              comentario: '',
                              id: Date.now() + Math.random(),
                              previewUrl,
                              isImage,
                              isVideo,
                              isPDF
                            };
                          });
                          
                          setSelectedFiles([...selectedFiles, ...newFiles]);
                          e.target.value = ''; // Reset input
                        }}
                      />
                      
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => document.getElementById('fileInput').click()}
                        disabled={loading || uploadingFiles}
                      >
                        <i className="fa fa-paperclip me-2"></i>
                        Seleccionar Archivos (Imágenes, PDF, Videos)
                      </button>
                      
                      {selectedFiles.length > 0 && (
                        <span className="ms-3 text-muted">
                          {selectedFiles.length} archivo(s) total
                          {selectedFiles.filter(f => f.isExisting && !f.isReplacing).length > 0 && 
                            ` (${selectedFiles.filter(f => f.isExisting && !f.isReplacing).length} existente(s), ${selectedFiles.filter(f => !f.isExisting).length} nuevo(s)${selectedFiles.filter(f => f.isReplacing).length > 0 ? `, ${selectedFiles.filter(f => f.isReplacing).length} a reemplazar` : ''})`
                          }
                        </span>
                      )}
                      </div>
                    )}
                    
                    {/* Lista de archivos seleccionados en grid de 3 columnas */}
                    {selectedFiles.length > 0 && (
                      <Row className="border rounded p-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                        {selectedFiles.map((fileData, index) => (
                          <Col md={4} key={fileData.id} className="mb-4">
                            <div className="border rounded p-2 h-100 d-flex flex-column">
                              {/* Preview de imagen, video o PDF */}
                              <div 
                                className="mb-2 d-flex align-items-center justify-content-center bg-light rounded file-preview" 
                                style={{ 
                                  height: '180px', 
                                  position: 'relative', 
                                  overflow: 'hidden',
                                  cursor: 'pointer',
                                  transition: 'transform 0.2s, box-shadow 0.2s'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.transform = 'scale(1.02)';
                                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.transform = 'scale(1)';
                                  e.currentTarget.style.boxShadow = 'none';
                                }}
                                onClick={(e) => {
                                  // No abrir el visor si se hizo clic en un botón
                                  // o en un elemento marcado explícitamente para NO abrir el preview
                                  const isButtonClick =
                                    e.target.tagName === 'BUTTON' || e.target.closest('button');
                                  const isNoPreviewElement =
                                    e.target.getAttribute('data-no-preview') === 'true' ||
                                    e.target.closest('[data-no-preview="true"]');

                                  if (isButtonClick || isNoPreviewElement) {
                                    e.stopPropagation();
                                    return;
                                  }

                                  openFileViewer(index);
                                }}
                              >
                                {fileData.isImage ? (
                                  <img 
                                    src={fileData.previewUrl} 
                                    alt={fileData.file.name}
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain' 
                                    }}
                                  />
                                ) : fileData.isVideo ? (
                                  <video 
                                    src={fileData.previewUrl}
                                    controls
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain' 
                                    }}
                                  />
                                ) : fileData.isPDF ? (
                                  <div className="text-center">
                                    <i className="fa fa-file-pdf fa-4x text-danger mb-2"></i>
                                    <div className="small text-muted">PDF</div>
                                  </div>
                                ) : (
                                  <div className="text-center">
                                    <i className="fa fa-file fa-4x text-secondary mb-2"></i>
                                    <div className="small text-muted">Archivo</div>
                                  </div>
                                )}
                                
                                {/* Ícono de ver en pantalla completa */}
                                <div 
                                  className="position-absolute file-preview-icon"
                                  style={{ 
                                    top: '50%', 
                                    left: '50%', 
                                    transform: 'translate(-50%, -50%)',
                                    opacity: 0,
                                    transition: 'opacity 0.2s',
                                    pointerEvents: 'none',
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    borderRadius: '50%',
                                    width: '60px',
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <i className="fa fa-search-plus fa-2x text-white"></i>
                                </div>
                                
                                {/* Input oculto para reemplazar archivo */}
                                {fileData.isExisting && actionMode === "U" && (
                                  <input
                                    type="file"
                                    accept="image/*,.pdf,video/*"
                                    id={`replaceFileInput-${index}`}
                                    data-no-preview="true"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                      const newFile = e.target.files[0];
                                      if (newFile) {
                                        // Validar tipo de archivo
                                        const isImage = newFile.type.startsWith('image/');
                                        const isPDF = newFile.type === 'application/pdf';
                                        const isVideo = newFile.type.startsWith('video/');
                                        
                                        if (!isImage && !isPDF && !isVideo) {
                                          toast({
                                            type: "warning",
                                            message: "Solo se permiten archivos de imagen, PDF o video"
                                          });
                                          return;
                                        }
                                        
                                        // Crear preview del nuevo archivo
                                        const previewUrl = (isImage || isVideo) ? URL.createObjectURL(newFile) : null;
                                        
                                        // Actualizar el archivo marcándolo para reemplazo
                                        const updatedFiles = [...selectedFiles];
                                        
                                        // Liberar la URL anterior si existe
                                        if (updatedFiles[index].previewUrl && updatedFiles[index].isReplacing) {
                                          URL.revokeObjectURL(updatedFiles[index].previewUrl);
                                        }
                                        
                                        updatedFiles[index] = {
                                          ...updatedFiles[index],
                                          newFile: newFile, // Guardar el nuevo archivo
                                          originalFileName: updatedFiles[index].file.name, // Mantener nombre original
                                          file: {
                                            ...updatedFiles[index].file,
                                            name: newFile.name,
                                            size: newFile.size
                                          },
                                          previewUrl: previewUrl || updatedFiles[index].previewUrl,
                                          isImage,
                                          isPDF,
                                          isVideo,
                                          isReplacing: true, // Marcar como archivo para reemplazar
                                        };
                                        
                                        setSelectedFiles(updatedFiles);
                                        e.target.value = ''; // Reset input
                                        
                                        toast({
                                          type: "info",
                                          message: `Archivo seleccionado para reemplazar: ${newFile.name}`
                                        });
                                      }
                                    }}
                                  />
                                )}
                                
                                {/* Botón reemplazar al lado del botón eliminar - Solo visible para archivos existentes en modo U */}
                                {fileData.isExisting && actionMode === "U" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary position-absolute"
                                    style={{ top: '5px', right: '45px', zIndex: 100, pointerEvents: 'auto' }}
                                    data-no-preview="true"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      document.getElementById(`replaceFileInput-${index}`).click();
                                    }}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                    }}
                                    disabled={loading || uploadingFiles}
                                    title="Reemplazar archivo"
                                  >
                                    <i className="fa fa-pen-to-square" style={{ pointerEvents: 'none' }}></i>
                                  </button>
                                )}
                                
                                {/* Botón eliminar en esquina superior derecha - Solo visible en modos I y U */}
                                {actionMode !== "C" && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger position-absolute"
                                    style={{ top: '5px', right: '5px', zIndex: 20, pointerEvents: 'auto' }}
                                    data-no-preview="true"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      
                                      console.log("🗑️ Click en eliminar archivo:", {
                                        index,
                                        fileName: fileData.file.name,
                                        isExisting: fileData.isExisting,
                                        currentPendingDelete: fileData.pendingDelete
                                      });
                                      
                                      // Mostrar confirmAlert con el mismo estilo que el guardado
                                      const mensajeConfirmacion = fileData.isExisting 
                                        ? "¿Confirma que desea eliminar este archivo"
                                        : "¿Confirma que desea eliminar este archivo?";
                                      
                                      confirmAlert({
                                        closeOnClickOutside: false,
                                        customUI: ({ onClose }) => {
                                          return (
                                            <div className="custom-ui text-center p-4" style={{ 
                                              backgroundColor: 'white', 
                                              borderRadius: '10px',
                                              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                              minWidth: '400px'
                                            }}>
                                              <h6 className="mb-3 fw-normal fs-5">{mensajeConfirmacion}</h6>
                                              <div className="d-flex justify-content-center gap-3 mt-4">
                                                <button
                                                  className="btn btn-cancel-hover"
                                                  onClick={() => {
                                                    console.log("🗑️ Eliminación cancelada por el usuario");
                                                    onClose();
                                                  }}
                                                  style={{ width: '120px' }}
                                                >
                                                  Cancelar
                                                </button>
                                                <button
                                                  className="btn btn-success"
                                                  onClick={async () => {
                                                    onClose();
                                                    
                                                    console.log("🗑️ Confirmando eliminación de archivo:", {
                                                      index,
                                                      fileName: fileData.file.name,
                                                      isExisting: fileData.isExisting
                                                    });
                                                    
                                                    // Si es un archivo existente, ejecutar el endpoint DELETE inmediatamente
                                                    if (fileData.isExisting) {
                                                      try {
                                                        // Obtener ID y GUID del registro actual
                                                        const idNovedad = selectedItem?.Id || formik.values.Id;
                                                        const guidNovedad = selectedItem?.GUID || formik.values.GUID;
                                                        
                                                        console.log("🗑️ Eliminando archivo del servidor:", {
                                                          idNovedad,
                                                          guidNovedad,
                                                          documentId: fileData.documentId,
                                                          fileName: fileData.originalFileName
                                                        });
                                                        
                                                        // Crear FormData para el DELETE
                                                        const formData = new FormData();
                                                        formData.append('Token', user.Token);
                                                        formData.append('IdUser', user.IdUser);
                                                        formData.append('IdNovedad', idNovedad);
                                                        formData.append('id', fileData.documentId);
                                                        formData.append('GUIDNovedad', guidNovedad);
                                                        formData.append('Documento', fileData.originalFileName);
                                                        
                                                        // Ejecutar DELETE
                                                        const response = await AxiosInstance.request({
                                                          method: 'DELETE',
                                                          url: 'api/OcupacionProcesos/NovedadesDocumentosFilesDel',
                                                          data: formData,
                                                          headers: {
                                                            'Content-Type': 'multipart/form-data'
                                                          }
                                                        });
                                                        
                                                        console.log("✅ Archivo eliminado del servidor:", response.data);
                                                        
                                                        // Eliminar del array
                                                        setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
                                                        
                                                        toast({
                                                          type: "success",
                                                          message: `Archivo "${fileData.file.name}" eliminado correctamente.`
                                                        });
                                                      } catch (error) {
                                                        console.error("❌ Error al eliminar archivo del servidor:", error);
                                                        toast({
                                                          type: "error",
                                                          message: `Error al eliminar el archivo "${fileData.file.name}". ${error.message || ''}`
                                                        });
                                                      }
                                                    } else {
                                                      // Archivo nuevo: simplemente eliminarlo del array
                                                      // Liberar URL del preview si es local
                                                      if (fileData.previewUrl && (!fileData.isExisting || fileData.isReplacing)) {
                                                        URL.revokeObjectURL(fileData.previewUrl);
                                                      }
                                                      console.log("🗑️ Eliminando archivo nuevo del array");
                                                      setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
                                                      toast({
                                                        type: "success",
                                                        message: `Archivo "${fileData.file.name}" eliminado.`
                                                      });
                                                    }
                                                  }}
                                                  style={{ width: '120px' }}
                                                >
                                                  Confirmar
                                                </button>
                                              </div>
                                            </div>
                                          );
                                        }
                                      });
                                    }}
                                    onMouseDown={(e) => {
                                      e.stopPropagation();
                                    }}
                                    disabled={loading || uploadingFiles}
                                    title="Eliminar archivo"
                                  >
                                    <i className="fa fa-times" style={{ pointerEvents: 'none' }}></i>
                                  </button>
                                )}
                              </div>
                              
                              {/* Nombre y tamaño del archivo - Solo visible en modos I y U */}
                              {actionMode !== "C" && (
                                <div className="mb-2">
                                  <div className="small fw-bold text-truncate" title={fileData.file.name}>
                                    <i className={`fa ${
                                      fileData.isImage ? 'fa-image' : 
                                      fileData.isVideo ? 'fa-video' : 
                                      'fa-file-pdf'
                                    } me-1`}></i>
                                    {fileData.file.name}
                                    {fileData.isReplacing && (
                                      <span className="badge bg-warning text-dark ms-2" style={{ fontSize: '0.65rem' }}>
                                        Se reemplazará
                                      </span>
                                    )}
                                  </div>
                                  <div className="small text-muted">
                                    {fileData.file.size > 0 ? `${(fileData.file.size / 1024).toFixed(2)} KB` : 'Archivo del servidor'}
                                  </div>
                                </div>
                              )}
                              
                              {/* Comentario */}
                              <div className="flex-grow-1">
                                <Form.Control
                                  as="textarea"
                                  placeholder={fileData.isExisting && actionMode === "C" ? "Comentario (solo lectura)" : "Comentario para este archivo (opcional)"}
                                  value={fileData.comentario}
                                  onChange={(e) => {
                                    const updatedFiles = [...selectedFiles];
                                    updatedFiles[index].comentario = e.target.value.toUpperCase();
                                    setSelectedFiles(updatedFiles);
                                  }}
                                  disabled={loading || uploadingFiles || (actionMode === "C" && fileData.isExisting)}
                                  readOnly={actionMode === "C" && fileData.isExisting}
                                  rows={3}
                                  style={{ 
                                    width: "100%", 
                                    minHeight: "90px", 
                                    resize: "vertical", 
                                    fontSize: '0.85rem',
                                    backgroundColor: (actionMode === "C" && fileData.isExisting) ? '#f8f9fa' : 'white',
                                    textTransform: 'uppercase'
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    )}
                  </Col>
                </Row>
              )}


            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex gx-3 align-items-center justify-content-end">
                {Object.values(formik.errors).length > 0 && (
                  <span className="invalid me-2">
                    Por favor, verificar los errores en el formulario
                  </span>
                )}

                {generalError ? <span className="invalid me-2">
                  {generalError}
                </span> : null}
                {/* 
                    - Add by Victor: Agrega color verde al boton Guardar, rojo al de Cerrar y aumenta el tamaño de ambos.
                    - Add by Victor: Cuando se consulte un registro en ReadOnly se visualiza el botón Cerrar de color Azul.                   
                */}
                <button 
                  className={`btn ${actionMode === "C" ? "btn-primary" : "btn-cancel-hover"} me-2`} 
                  type="button" 
                  onClick={() => {
                    // Limpiar URLs de preview (solo los locales)
                    selectedFiles.forEach(fileData => {
                      if (fileData.previewUrl && !fileData.isExisting) {
                        URL.revokeObjectURL(fileData.previewUrl);
                      }
                    });
                    setSelectedFiles([]); // Limpiar archivos
                    toggleOpen(null);
                  }} 
                  disabled={loading || uploadingFiles}
                  style={{ width: "155px", height: "40px" }}
                >
                  {actionMode === "C" ? "Cerrar" : "Cancelar"}
                </button>
                {actionMode !== "C" && (
                  <button 
                    className="btn btn-success" 
                    type="button" 
                    onClick={() => [formik.submitForm()]} 
                    disabled={loading || uploadingFiles}
                    style={{ width: "155px", height: "40px" }}
                  >
                    {loading || uploadingFiles ? (
                      uploadingFiles ? 'Subiendo archivos...' : 'Guardando...'
                    ) : (
                      'Guardar'
                    )}
                  </button>
                )}
              </div>
            </Modal.Footer>
          </Form>
        </Modal> : null}
      
      {/* Modal Visor de Archivos en Pantalla Completa */}
      {viewerOpen && selectedFiles.length > 0 && (
        <Modal
          show={viewerOpen}
          onHide={closeFileViewer}
          size="xl"
          fullscreen={true}
          centered
          className="file-viewer-modal"
        >
          <Modal.Header closeButton closeVariant="white" style={{ backgroundColor: '#000', color: '#fff', border: 'none' }}>
            <Modal.Title>
              {selectedFiles[currentFileIndex]?.file.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ 
            backgroundColor: '#000', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            position: 'relative',
            padding: '20px'
          }}>
            {/* Contenido del archivo */}
            <div style={{ 
              width: selectedFiles[currentFileIndex]?.isPDF ? '95%' : 'auto',
              maxWidth: selectedFiles[currentFileIndex]?.isPDF ? '95%' : '100%', 
              maxHeight: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              {selectedFiles[currentFileIndex]?.isImage && (
                <img 
                  src={selectedFiles[currentFileIndex].previewUrl} 
                  alt={selectedFiles[currentFileIndex].file.name}
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: 'calc(100vh - 150px)', 
                    objectFit: 'contain' 
                  }}
                />
              )}
              
              {selectedFiles[currentFileIndex]?.isVideo && (
                <video 
                  src={selectedFiles[currentFileIndex].previewUrl}
                  controls
                  autoPlay
                  style={{ 
                    maxWidth: '100%', 
                    maxHeight: 'calc(100vh - 150px)', 
                    objectFit: 'contain' 
                  }}
                />
              )}
              
              {selectedFiles[currentFileIndex]?.isPDF && (
                <iframe
                  src={selectedFiles[currentFileIndex].previewUrl}
                  style={{ 
                    width: '100%', 
                    height: 'calc(100vh - 150px)',
                    border: 'none',
                    minWidth: '100%'
                  }}
                  title={selectedFiles[currentFileIndex].file.name}
                />
              )}
            </div>
            
            {/* Flechas de navegación */}
            {selectedFiles.length > 1 && (
              <>
                <button
                  className="btn btn-light position-absolute"
                  style={{ 
                    left: '20px', 
                    top: '50%', 
                    transform: 'translateY(-50%)',
                    opacity: 0.8,
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%'
                  }}
                  onClick={goToPreviousFile}
                  title="Anterior"
                >
                  <i className="fa fa-chevron-left fa-lg"></i>
                </button>
                
                <button
                  className="btn btn-light position-absolute"
                  style={{ 
                    right: '20px', 
                    top: '50%', 
                    transform: 'translateY(-50%)',
                    opacity: 0.8,
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%'
                  }}
                  onClick={goToNextFile}
                  title="Siguiente"
                >
                  <i className="fa fa-chevron-right fa-lg"></i>
                </button>
              </>
            )}
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: '#000', color: '#fff', border: 'none' }}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              {selectedFiles[currentFileIndex]?.comentario && (
                <div className="text-white" style={{ fontSize: '1rem', marginTop: '8px' }}>
                  {selectedFiles[currentFileIndex].comentario}
                </div>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      )}
      
      {section?.FormPath && <Breadcrumbs pathTitle={section?.FormPath} />}
      <Container>
        <div className="row mx-0" >
          <div className="col-12">
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-2 mt-2">

              <React.Fragment>
                <div className="d-flex align-items-center my-1">
                  <i className={section.FormIcon + " me-3 fa-2x"}></i>
                  <div className="d-flex flex-column">
                    <h5 className={"my-1"}>{section.FormTitle}

                    </h5>
                  </div>
                </div>
              </React.Fragment>
              {loading ? (
                <React.Fragment>
                  <div className="">
                    <div className="w-25 mx-auto my-1" style={{ paddingTop: "" }}>
                      <div className="" role="status" style={{ border: 'none' }}>
                        <span className="visually-hidden">Cargando...</span>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              ) : null}
                
              <div className="w-auto d-flex align-items-center">

               {selectedItem ? (
                  <>

                    <button className="btn btn-sm  my-1 me-2" title="Ver" disabled={loading} onClick={() => toggleOpen("C")}>
                      <i className="fa fa-eye"></i>
                    </button>


                  </>
                ) : null}

              </div>
                 
            </div>
            {loadGRIDUI()}
          </div>
        </div>
      </Container>

      {/* Modal de error de la API */}
      <ErrorModal />
    </React.Fragment>
  );
}

// Estilos CSS personalizados para el botón de cerrar del modal
const styleElement = document.createElement('style');
styleElement.textContent = `
  .modal-header .btn-close {
    border: 1px solid #6c757d !important;
    border-radius: 0.25rem !important;
    padding: 0.5rem !important;
    opacity: 1 !important;
    background-color: white !important;

  }
  
  .modal-header .btn-close:hover {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
  }
  
  .modal-header .btn-close:hover::before,
  .modal-header .btn-close:hover::after {
    background-color: white !important;
  }
`;
if (typeof document !== 'undefined' && !document.getElementById('modal-close-button-styles')) {
  styleElement.id = 'modal-close-button-styles';
  document.head.appendChild(styleElement);
}
